const translations = {
    tr: "Turkish",
    en: "English",
    // A
    admin: "Admin",
    administrative_document_management: "Administrative Document Management",
    are_you_sure_you_want_to_change_the_status_quo: "Are You Sure Want To Change The Status Quo",
    added: "Added",
    makeup_exam_data_placeholder: "e.g. 2001001,MATH101",
    makeup_exam_data_help_text: "Enter 'Student Number,Course Code' on each line.",
    add_student: "Add Student",
    add_student_number: "Add Student Number",
    add_all_student_without_payment_approval: "Add All Student Without Payment Approval",
    archive: "Archive",
    abroad_application: "International Application",
    abroad: "Abroad",
    add_NI_slot: "Add NI Slot",
    absent_without_excuse: "Absent Without Excuse",
    absent_with_excuse: "Absent With Excuse",
    add_unlisted_education: "Add unlisted education information",
    application_resume_info_text: "If your application is interrupted, you can continue where you left off by visiting <a href=https://umis.bau.edu.tr/special-student/application/login>login </a> with your PIN code.",
    academic_season_term_applied: "Academic Season-Term Applied",
    visitor_application_resume_info_text: "If your application is interrupted, you can continue where you left off by visiting <a href=https://umis.bau.edu.tr/visitor-student/application/login>umis.bau.edu.tr/visitor-student/application/login </a> with your PIN code.",

    absent: "Absent",
    applied_program_info: "Applied Program Information",
    available_chairs: "Available Chairs",
    your_reservation: "Your Reservation",
    library_reservation: "Library Reservation",
    library_reservation_punishments: "Library Reservation Punishments",
    library_reservation_punishment: "Library Reservation Punishment",
    punished_students: "Punished Students",

    absence_report: "Absence Report",
    academic_unit_office: "Academic Unit Office",
    academic_advisor_approval_date: "Academic Advisor Approval Date",
    academic_advisor_approval: "Academic Advisor Approval",
    academic_information: "Academic Information",
    academic_year: "Academic Year",
    academic_council_order: "Academic Council Order",
    agreements: "Aggreements",
    acceptance_data: "Acceptance Data",
    acceptance_date: "Acceptance Date",
    acceptance_date_start: "Acceptance Start Date",
    acceptance_date_end: "Acceptance End Date",
    acceptance_letter: "Acceptance Letter",
    accepttance_not_accepted: "Not Accepted",
    accepted: "Accepted",
    activity_report: "Activity Report",
    accepttance_status: " Acceptance Status",
    account_code: "Account Code",
    account_holder: "Account Holder",
    account_information: "Account Information",
    account_number: "Account id",
    action: "Action",
    active: "Active",
    achievement_ranking_control: "Achievement Ranking Control",
    advisor_approval: "Advisor Approval",
    attachment_cut_form: "Attachment Cut Form",
    active_semester: "Active Semester",
    activate_graduate_email: "Activate Graduate Email",
    achievement_ranking_of_intermediate_class: "Achievement Ranking of Intermediate Class",
    adaptation_request: "Adaptation Request",
    approve_1: "Approval",
    attendance_detail: "Attendance Detail",
    attendance_entry: "Attendance Entry",
    attendance_requirement: "Attendance Requirement",
    attendees_for_refreshments: "Attendees for Refreshments",
    attended_university: "Attended University",
    available_roles: "Available Roles",
    add: "Add",
    add_exam_score: "Add Exam Score",
    add_bank_credit: "Add Student Credit (Deposit) Bank Account",
    add_credit_price: "Add Credit Price",
    add_course: "Add course",
    add_course_transfer: "Add Course Transfer",
    add_discount: "Add Discount",
    add_education_credit: "Add Education Credit",
    are_you_sure_online_registration: "Are you sure you want to complete your final registration for the program you have been placed in?",
    add_module: "Add Module",
    are_you_sure_to_copy: "Are You Sure To Copy",
    add_new_course: "Add New Course",
    add_note: "Add Note",
    application_group: "Application Group",
    add_offset: "Add Offset",
    add_date: "Add Date",
    add_offset_payment: "Add Offset Payment",
    add_option: "Add Option",
    add_payment: "Add Payment",
    add_payment_plan: "Create Payment Plan",
    add_pdf: "Add Pdf",
    add_preference: "Add Preference",
    add_preference1: "Add Preference",
    add_refund: "Add Refund",
    add_scholarship: "Add Scholarship",
    add_slot: "Add Slot",
    adapted_class: "Class for Adaptation",
    added_by: "Added By",
    added_course_transfer: "Added Course Transfer",
    added_date: "Added Date",
    additional_lecturer: "Additional Instructor",
    additional_lecturers: "Additional Instructors",
    address: "Address",
    address_2: "Full Address",
    address_en: "Address (EN)",
    address_information: "Address Information",
    address_update: "Update your Address",
    advance_payment: "Advance Payment",
    advisor: "Advisor",
    advisor_id: "Advisor ID",
    advisor_name: "Advisor's Name",
    advisor_of_project: "Project Advisor",
    advisor_of_thesis: "Thesis Advisor",
    advisor_surname: "Advisor's Surname",
    advisored_of_students: "Advising",
    affiliated_curriculum: "Affiliated Curriculum",
    already_available: "Already Available",
    align: "Align",
    available: "Available",
    all: "All",
    all_exam_scores: "All Exam Scores",
    all_registrations: "All Registrations",
    allow_classroom_overlap: "Allow Classroom Overlapping",
    allow_instructor_overlap: "Allow Instructor Overlapping",
    allow: "Allow",
    allow_epayment: "Allow E-Payment",
    all_permit_yok_report: "All Permit YOK Report",
    allow_vinov: "Allow Vinov",
    all_tl: "All in TRY",
    alumni: "Alumni",
    alumni_card_status: "Alumni Card Status",
    amount: "Amount",
    amount_paid: "Amount paid",
    amount_tl: "Amount (TL)",
    amount_to_be_paid: "Amount to be Paid",
    and: "and",
    api_config: "Api Config",
    add_content: "Add Content",
    application_conditions: "Application Conditions",
    application_completion_status: "Application Completion Status",
    application_date: "Date of Application",
    application_date_hour: "Application Date and Time",
    application_follow_link: "Application Follow Link",
    application_information: "Application Information",
    application_new: "Application New",
    application_period: "Period of Application ",
    application_rules: "Application Rules",
    application_status: "Application Status",
    application_status_update: "Application Status Update",
    update_statuses: "Update Statuses",
    application_status_reset_are_you_sure: "Are You Sure You Want to Reset Application Status??",
    application_delete: "Application Delete",
    application_approve: "Application Approve",
    process_results: "Process Results",
    application_send: "Application Send",
    application_start_date: "Application Start Date",
    application_end_date: "Application End Date",
    application_send_waiting: "Waiting for You to Submit Application",
    application_success: "Application Success",
    application_success_title: "Application Completed Successfully!",
    application_success_description: "Your application has been successfully submitted. You can return to the login screen to track your application.",
    application_success_hint: "Your username and password will be sent to your registered email address.",
    application_success_info: "Application Success İnfo",
    application_summary: "Application Summary",
    application_system: "Application System",
    application_type: "Application Type",
    approved_academic_unit_office: "Approved Academic Unit Office",
    application_types: "Application Types",
    application_update_success: "Application Update Success",
    application_withdraw_display: "Application Withdraw Display",
    applications: "Applications",
    application_status_reset: "Reset Application",
    announcement_entry: "Announcement Entry",
    announcement: 'Announcements',
    announcements: 'Announcements',
    application: "Application",
    application_result: {
        placed: "Placed",
        other_preference_placed: "Other Preference Placed",
        not_placed: "Not Placed",
        registered: "Registered",
    },
    applied_faculty: "Applied Faculty",
    applied_program: "Applied Program",
    apply: "Apply",
    apply_bau_application: "Apply Bau Application",
    apply_cash_discount: "Apply Cash Discount",
    apply_scholarship: "Apply for Scholarship",
    approval_phase: "Approval Phase",
    approval_procedures: "Approval Procedures",
    approval_letter: "Approval Letter",
    approval_registration_succes_msg:
        "Online registration procedure successfully completed.",
    approval_status: "Approval Status",
    approve: "Approve",
    approve_request: "Approve Request",
    approve_or_reject_confirm: "Approve or Reject (Confirmation Modal)?",
    approve_step: "Approve Step",
    approve_step_error: "You must enter a approve step",
    approval_template: "Approval Step Template",
    approved: "Approved",
    approved_go: "Send for approvel",
    approved_by: "Approved by",
    approved_date: "Approved Date",
    approvers: "Approvers",
    average_price_report: "Average Price Report",
    apply_to: "Apply to",
    approver: "Approver",
    approver_name: "Approver Name",
    approver_surname: "Approver Surname",
    approve_sms: "Approve Sms",
    approve_email: "Approve Email",
    approve_call: "Approve Call",
    apply_now: "Apply now",
    are_you_sure_to_apply: "Are you sure to apply",
    are_you_sure_to_cancel: "Are you sure you want to cancel?",
    are_you_sure_to_exam_score_calculate: "Are you sure you want to calculate the exam score?",
    are_you_sure_to_set_active: "Are you sure you want to set active?",
    ebys_send: "EBYS Send",
    clear_ebys: "Delete from EBYS",
    ebys_id: "EBYS ID",
    ebys_status: "EBYS Status",
    ebys_send_statement: "Are you sure you want to send to EBYS?",
    ebys_clear_statement: "Are you sure you want to delete from EBYS?",
    edit: "Edit",
    are_you_sure_to_restore_preference: "Are you sure you want to reset preference?",
    are_you_sure_to_create_a_new_proforma_invoice:
        "Are you sure to create a new proforma invoice",
    are_you_sure_to_delete: "Are you sure you want to delete?",
    are_you_sure_to_approve: "Are you sure you want to approve?",
    are_you_sure_to_give_exceptional_payment_approval:
        "Are you sure to give exceptional payment approval?",
    are_you_sure_to_move: "Are you sure to move",
    are_you_sure_to_remove_exceptional_payment_approval:
        "Are you sure to remove exceptional payment approval?",
    are_you_sure_to_send: "Are you sure to send",
    are_you_sure_to_withdraw:
        "Are you sure that you want to withdraw from the course?",
    are_you_sure_want_save: "Are you sure want save",
    are_you_sure_to_start_process: "Are you sure to start process",
    are_you_sure_you_want_to_take_the_x_course:
        "Are you sure you want to take the course '{course_name}'-'{course_code}'?",
    are_you_sure_you_want_to_update_the_approval_status:
        "Are you sure you want to update your approval status?",
    are_you_sure_want_course_language: "Are you sure you want to take the course language {0}",
    are_you_sure_to_ticket_approved: "Are you sure to ticket approved?",
    asal: "Department of Recruitment",
    asal_delay_reasons: "Asal Delay Reasons",
    asal_maximum_time_reasons: "Asal Maximum Time Reasons",
    asal_type: "Asal Type",
    asynchronous: "Asynchronous",
    at_which_unit: "At Which Unit",
    attendance_hours: "Attendance Hours",
    attendance_date: "The Date Attendance is Taken",
    attendance_list: "Attendance List",
    attendance_report: "Attendance Report",
    attendees: "Attendees",
    attended_the_exam: "Attended the Exam",
    allergy_information: "Allergy Information",
    attention: "Attention",
    attention_for_thesis_and_project:
        "During the Course Registration Period you must register for the course. Thesis 1-Seminar/Project/Proficiency displayed on the Course Selection Webpage",
    authorizations: "Authorizations",
    pin_reminder_info_text: "Please enter your registered ID number and date of birth. Your PIN code will be sent to your registered email address again.",
    pin_sent_success: "Your PIN code has been sent to your email address.",
    are_you_sure_make_application: "Are you sure you want to submit your application??",
    autumn: "Fall",
    available_hours: "Available Hours",
    average_system_100: "Average System 100",
    average_system_4: "Average System 4",
    attended: "Present",
    application_images: "Application Images",
    application_message: "Your application has been received. If it is negative within the evaluation criteria, an information email will be sent. Upon approval, your ticket will be sent to you by email within 1 week.",
    alternative_tel: "Alternative Phone",
    auto_course_registration: "Automatic Course Registration",
    auto_repeat_course_registration: "Automatic Repeat Course Registration",
    auto_irregular_course_registration: "Automatic Irregular Course Registration",
    assign_doesnt_have_payment_approval: "Assign Doesnt Have Payment Approval",
    go_to_login: "Go to Login Screen",
    back_to_login: "Back to Login Screen",
    assign_doesnt_have_course_registration: "Assign Doesnt Have Course Registration",
    associate_professor_field: "Associate Professor Field",
    associate_professor_title_date: "Associate Professor Title Date",
    associate_professor_appointment_date: "Associate Professor Appointment Date",
    annex: "Annex",
    answer_force: "Reply",
    attached_files: "Attached Files",

    // B
    bachelor_graduation_date: "Bachelor Graduation Date",
    back: "Back",
    bay_atlantic_university: "Bay Atlantic University",
    bahcesehir_university: "Bahcesehir University",
    bahcesehir_accommodation_and_tourism: "Bahcesehir Accommodation and Tourism Investments Inc.",
    balance: "Balance",
    balance_overflow: "Insufficient balance",
    bank: "Bank",
    back_side: "Back Side",
    card: "Bank Cart",
    bank_additional_installment: "Bank Additional Installment",
    bisep_applications: "Bisep Applications",
    bank_credit: "Bank Credit",
    bank_credit_cash: "Bank Credit Cash",
    bank_id: "Bank Name",
    bank_name: "Name of Bank",
    banks: "Banks",
    balance_report: "Balance Report",
    basic_field_type: "Basic Field Type",
    bank_reference_code: "Bank/Reference Code",
    batch_gno_calculation:
        "Calculation of Institutional Cumulative Grade Point Average",
    batch_update_due_date: "Batch Update Due Date ",
    batch_course_term_information_update: "Batch Course Term Information Update",
    bulk_student_transfer: "Bulk Student Transfer",
    batch_score_entry_note: "Bulk Grade Entry",
    bulk_student_transfer_excel: "Bulk Student Transfer",
    bulk_student_slot_update: "Bulk Student Slot Update",
    blood_group: "Blood Group",
    bls_first_aid_certificate: "BLS and First Aid Certificate",
    bulk_registration_document_download: "Bulk Registration Document Download",
    bulk_registration_ebys_download: "Bulk EBYS Document Download",
    bulk_yoksis_freeze_registration_data_transfer: "Bulk Yoksis Freeze Registration Data Transfer",
    bulk_grading_system_update: "Bulk Grading System Update",
    bulk_attendance_hour_update: "Attendance  update",
    bulk_attendance_hour_success:
        "Program ID: {student_program_id} Module: {module} Level: {level} Class: {class} the absence hour has been successfully updated.",
    bulk_attendance_hour_unsuccess:
        "Program ID: {student_program_id} Module: {module} Level: {level} Class:{class} the absence hour has not been updated.",
    bau_grade_conversion: "Bau Grade Conversion",
    bau_grades: "Bau Grades",
    bau_email: "Bahçeşehir University E-mail",
    bau_email_rules_message: "Please enter a valid Bahçeşehir University e-mail address.",
    bau_language_exam_info: "Bau Language Info",
    bau_language_exam_question: "Bau Language Exam Questions",
    before_leave_of_absence: "Have you taken leave of absence at school?",
    birthdate: "Birthdate",
    birth_date: "Birthdate (YYYY-mm-dd)",
    birthdate_from: "Birthdate From",
    birthdate_to: "Birthdate To",
    birthplace: "Birthplace",
    board_decision: "Board Decision",
    board_decisions: "Board Decisions",
    board_members: "Board Members",
    board_types: "Board Types",
    bonus_course_credit_limit: "Bonus Course Credit Limit",
    branch_name: "Branch Name",
    branch_type: "Branch Type",
    branch: "Branch",
    browse: "Browse",
    building: "Buildings",
    building_id: "Building Id",
    bulk_certificate_submission: "Bulk Certificate Submission",
    bulk_document_creation: "Bulk Document Creation",
    bulk_graduation: "Bulk Graduation",
    buy: 'Buy',
    building_information: 'Building Information',
    bulk_section_update: "Bulk Section Update",
    bulk_translation: "Bulk Translation",
    bulk_quota_assignment: "Bulk Quota Assignment",
    bulk_contact_information_update: "Bulk Contact Information Update",
    budget: "Budget",
    bulk_delete: "Bulk Delete",
    budget_items: "Budget Items",
    bulk_file_download_btn: "B.File.D",
    blue_card_issue_date: "The date the blue card was issued",
    before_placed: "Has previously been placed in a higher education program?",
    business_partner_meeting: "Business Partner Meeting",
    by_hand: "By hand",
    blue_card_expiry_date: "Blue Card Expiry Date",
    bulk_grade_entry_processing_info: "Do not close the window or tab, and do not perform any actions during the process.",
    bin_list: "BIN List",
    bin_range_list: "BIN Range List",

    // C
    card_created: 'Card Created',
    card_not_created: 'Card Not Created',
    calculate: "Calculate",
    calculate_extra_graduate_courses: "Additional Graduation Courses",
    course_agreement_suspension_control: "Course Agreement Suspension Control",
    assign_semester_status_by_yoksis_max_duration: "Update Student Semester Status Exceeding Maximum Duration",
    calculated_cgpa: "Calculated CGPA",
    calculated_gpa: "Calculated GPA",
    calculate_refund: "Calculate Refund",
    no_students_enrolled_in_the_course: 'No Students Enrolled In the course.!',
    calculate_number_of_semesters: "Calculate Number of Semesters",
    campus: "Campuses",
    campus_address: "Campus Address",
    campus_id: "Campus Id",
    campus_name: "Campus Name",
    library_room_name: "Library Room Name",
    campus_information: "Campus Information",
    can_approvers: "Authorized Approvers",
    cars: "Cars",
    car_brands: "Car Brands",
    car_responsible: "Responsible",
    car_receiver: "Car Receiver",

    car_brand: "Car Brand",
    car_model: "Car Model",
    car_models: "Car Models",
    cargo: "Cargo",
    course_type_name: "Course Type Name",
    course_agreement: "Course Agreement",
    course_credit: "Course Credit",
    course_registration_rule: "Course Registration Rule",
    can_be_repeated: "Can it be repeated?",
    can_take_same_semester: "Can be taken in the same semester",
    can_not_empty_classrooms: "Classroom list can not be empty.",
    cancel: "Cancel",
    cancel_application: "Cancel Application",
    cancel_to_move: "Cancel To Move",
    cancellation: "Cancellation",
    cancellation_amount: "Cancellation Amount",
    cancellation_reason: "Cancellation Reason",
    bulk_cancel: "Bulk Cancel",
    cancelled: "Cancelled",
    cancelled_payment_report: "Cancelled Check / Bill Report",
    cannot_overflow_balance: "Cannot Overflow Balance",
    capacity: "Capacity",
    course_outcomes: "Course Outcomes",
    course_transfer_total_ects_credit: "Total Number of Adapted ECTS Credits",
    card_holder_address: "Cardholder Address",
    card_holder_name: "Cardholder Name",
    card_holder_phone: "Cardholder Phone",
    card_name: "Card Name",
    card_name_en: "Card Name (EN)",
    card_no: "Card Number",
    course_agreement_form: "Course Agreement Form",
    course_agreement_status_update: "Status Update",
    course_agreement_form_selected_course_message: "You're about to select the course, do you confirm?",
    card_number: "Card Number",
    card_owner: "Card Owner",
    card_status: "Card Status",
    card_type: "Card Type",
    cash: "Cash",
    cash_campaign: "Cash Campaign",
    cash_campaign_link: "Cash Campaign Link",
    cash_collection_report: "Cash Collection Report",
    cash_discount_rate: "Cash Discount Rate",
    cash_discount_rate_certificate: "Cash Discount Rate",
    cash_in_advance: "Cash in Advance",
    cash_or_installed: "Cash / Installed",
    cash_payment: "Cash Payment",
    cash_payment_type: "Cash Payment Type",
    car_reservations: "Car Reservations",
    car_reservations_empty_reservations: "Car Reservations Empty Reservations",
    category: "Category",
    cert_type: "Certificate Type",
    corporation: "Corporation",
    corp_department: "Corp Department",
    course_activity: "Course Activity",
    course_assigner: "Course Assigner",
    course_registration_date: "Course Registration Date",
    certificate: "Certificate",
    certificate_programs: "Certificate Programs",
    certificate_application: "Certificate Application",
    certificate_application_bulk_ebys_send: "Bulk EBYS Submission",
    certificate_selected: "Certificate Selected",
    certificate_center: "Certificate Center",
    certificate_centers: "Certificate Centers",
    certificate_centers_certificate: "Certificate Center Certificate",
    course_program_outcomes: "Course Program Outcomes",
    coordinator_approval: "Coordinator Approval",
    certified: "Certified",
    noncertified: "Non-certified",
    certificate_id: "Certificate İd",
    certificate_payments_report: "Certificate Payments Report",
    certificate_center_id: "Certificate Center Id",
    certificates_id: "Certificate Id",
    certificate_upload: "Please upload the digital copy of your certificate below",
    work_certificate_upload: "Work Certificate (Optional)",
    work_certificate_approval: "Current Services Approval",
    certificate_information: "Certificate İnformation",
    certificate_name: "Certificate Name",
    certificate_name_en: "Certificate Name En",
    certificate_show: "Certificate Show",
    certificate_person: "Certificate Persons",
    certificate_persons: "Attendee",
    certificate_date_between: "Certificate Creation Date Range",
    certificateshow: "Certificateshow",
    certificates_name: "Name",
    cgpa: "CGPA",
    gpa_calculate: "GPA Calculate",
    gpa_calculate_success: "Average calculated successfully! New Average: ",
    gpa_control_report: "GNO Control Report",
    gpa_calculate_info_text: "The student's GPA will be recalculated. Do you approve the transaction ?",
    change: "Change",
    change_status: "Change Status",
    change_user: "Change User",
    change_your_password: "Change Your Password",
    change_price: "Change Price",
    courses_with_approved_enrollment: "Programs With Approved Enrollment",
    change_section: "Change Section",
    change_student_group_radio: "Change Student Group",
    course_topics: "Course Topics",
    changes_will_be_saved:
        "The changes will be saved. Do you confirm the Procees?",
    check: "Check",
    check_drawer: "Check Drawer",
    check_it: "Verify",
    check_it_title: "Check İt Title",
    check_no: "Check No",
    check_payment_approval: "Verify Payment Approval",
    children_available: "Children Available",
    create_password: "Create Password",
    create_a_vote: "Create a Vote",
    create_amnesty_law_application: "Create Amnesty Law Application",
    choose_student_type_confirm_text: "Select New Student Registration",
    chose_your_double_major: "Chose Your Double Major",
    cities: "Cities",
    city: "City",
    city_id: "City",
    city_name: "City Name",
    clarification_text: "Clarification Text",
    class: "Class",
    classrate: "Percentile in Class",
    class_applied: "Class Applied",
    class_average: "Class Average",
    class_settings: "Class Settings",
    class_x: "%{class}st Class",
    classroom: "Classroom",
    classroom_list: "Classroom List",
    classroom_: "Classroom_",
    classroom_id: "Classroom ID",
    classroom_name: "Classroom Name",
    classroom_name_en: "Classroom Name (EN)",
    classroom_programs: "Classroom Programs",
    classroom_types: "Classroom Types",
    classrooms: "Classrooms",
    classroom_not_selected: "Classroom Not Selected",
    clear: "Clear",
    clear_filters: "Clear Filters",
    click_to_choose: "Click to select.",
    clinical_practice_internship_certificate: "Clinical Practice and Internship Certificate",
    close: "Close",
    closing_date: "Closing Date",
    close_edit_at: "Close Edit At",
    close_lessons_only: "Close Courses Only",
    classroom_spaces: "Classroom Spaces",
    conservatory_login_info: "Candidates who have previously applied for our Special Talent Exams must log into the page they previously applied for on UMİS, review all their information, update if necessary, and save it in order to apply for the Additional Quota Special Talent Exam.",
    conservatory_quotas: "Conservatory Quotas",
    club_type: "Club Type",
    club_president: "Club President",
    members: "Candidates",
    member: "Member",
    clup: "Club",
    coming_from_university: "University of Origin",
    cannot_find_grade_conversion: "Grade Scale Not Found.",
    course_coordinator_assignment: "Course Coordinator Assignment",
    course_detail: "Course Detail",
    course_code_option: "Turkish Courses and Certificate Programs",
    course_loads: "Course Loads",
    composition_arrangement: "Composition Arrangement",
    classical_turkish_music: "Classical Turkish Music",
    cartoon_animation_applications: "Cartoon Animation Applications",
    cartoon_animation_app_payment_info: "Cartoon Animation Application Payment Info",
    control_date: "Control Date",
    completed: "Completed Credit",
    count_of: "Count Of",
    classic_music: "Classic Music",
    club: "Club",
    club_votes: "Club Votes",
    create_club_event: "Create Club Event",
    club_name: "Club Name",
    code: "Code",
    coefficient: "BAU Grade Coefficient",
    collection_bank: "Collection Bank",
    collection: "Collection",
    complaint: "Complaint",
    collection_and_numbers_report: "Collection and Numbers Report",
    course_registration_without_payment_report: "Course Registration Without Payment Report",
    collection_report: "Collection Report",
    collection_screen: "Collection Screen",
    collective_consultant_appointment: "Collective Consultant Appointment",
    completed_status: "Completed",
    confirmation_result: "Confirmation Result",
    conference_hall: "Conference Hall",
    convert_i_grades: "Convert Missing Grades to I Grade",
    collective_student_thesis_topic_determination: "Collective Student Thesis Topic Determination",
    complete_your_payment: "Complete Your Payment",
    complate_your_purchase: "Complate Your Purchase",
    columns: "Columns",
    comment: "Comment",
    comment_questions: "Comment Questions",
    comment_answers: "Comment Answers",
    communication_address: "Contact Address",
    communication_address_2: "Communication Address",
    communication_city: "Communication City",
    communication_district: "Communication District",
    compass_dates: "Compass Dates",
    company_address: "Company Address",
    company_name: "Company Name",
    company_name_en: "Company Name (EN)",
    company_phone: "Company Phone",
    compensation_certificate: "Compensation Certificate",
    complaint_petition: "Complaint Petition",
    complete_registration: "Complete your Registration",
    completed_akts_credit: "Completed ECTS Credits",
    completed_credit: "Completed Credits",
    copying_course_outcomes_program_outcomes_matrix: "Copying the Course outcomes/Program outcomes Matrix",
    completed_ects_credit: "Completed Ects Credit",
    completed_slots: "Completed Slots",
    copy_course_outcome_matrix: "Copy the course-outcome matrix",
    completed_required_course_count: "Completed Required Course Count",
    completed_required_ects_credit: "Completed Required Ects Credit",
    completed_required_credit: "Completed Required Credit",
    completed_gep_course_count: "Completed GEP Course Count",
    completed_gep_ects_credit: "Completed GEP Ects Count",
    completed_gep_credit: "Completed GEP Credit",
    completed_dep_course_count: "Completed DEP Course Count",
    completed_dep_ects_credit: "Completed DEP Ects Count",
    completed_dep_credit: "Completed DEP Course Credit",
    completed_non_dep_course_count: "Completed NON DEP Course Count",
    completed_non_dep_ects_credit: "Completed NON DEP Ects Count",
    completed_non_dep_credit: "Completed NON DEP Course Credit",
    complimentary: "Complimentary",
    confirm: "Confirm",
    confirmation: "Confirmation",
    conditional_registration: "Conditional Registration",
    conflict_informations: "Conflict İnformation",
    constants: "Constants",
    contact: "Contact",
    contact_confirmations: "Contact Confirmations",
    contact_address_information: "Contact Address Information",
    contact_information: "Contact Information",
    contact_information_reports: "Contact İnformation Reports",
    contact_number: "Contact Number",
    contact_support: "Contact Support",
    conservatory: "Conservatory",
    conservatory_app_approve: "I Have Read and Accept the Application Requirements",
    conservatory_app_approve_multimedia: "I Consent to the Use of My Audio, Visual, Photo, and Video Recordings Within the Scope of the Consent Form",
    conservatory_applications: "Conservatory Applications",
    conservatory_publish_results: "Publish Results",
    conservatory_calc_placement_points_btn: "Calculate Placement Points",
    conservatory_application_exam_types: "Conservatory Application Exam Types",
    course_drop_process: "Course Drop Process",
    content: "Content",
    contents: "Contents",
    continue: "Continue",
    contract_type: "Contract Type",
    conservatory_contact_info: "For urgent inquiries, you can send an email to the Conservatory School at info@cons.bau.edu.tr.",
    controller_name: "Controller Name",
    coop_certificate: "Coop Certificate",
    coop_courses: "Coop Courses",
    coopstudentcertificate: "Coopstudentcertificate",
    coop_and_public_scholarship: "COOP and Public Scholarship",
    coop_scholarship: "COOP Scholarship",
    commission_rate: "Commission Rate",
    course_selection_credit_limit: "Course Selection Credit Limit",
    coop_scholarship_student_report: "Coop Scholarship Student Report",
    coop_internship_postings: "Internship Postings",
    coop_company: "Company",
    coop_position: "Position",
    coop_posting_responsible: "Posting Responsible",
    coop_location: "Location",
    coop_quota: "Quota",
    coop_last_application_date: "Last Application Date",
    coop_fee: "Fee",
    coop_posting_detail_apply: "Posting Detail / Apply",
    coop_posting_info: "Posting Information",
    coop_company_intro: "Company Introduction",
    coop_required_qualifications: "Required Qualifications",
    coop_provided_benefits: "Provided Benefits",
    coop_application: "Application",
    coop_available_working_days: "My Available Working Days",
    coop_select_cv: "Select CV",
    coop_submit_application: "Submit Application",
    coop_kvkk_approval_text: "I have read and approve the KVKK text.",
    coop_terms_approval_text: "I have read, understood and accept the Co-op terms.",
    coop_please_select_cv: "Please select a CV.",
    coop_please_approve_terms: "Please approve the KVKK text and the Co-op terms.",
    coop_application_draft: "Draft",
    coop_application_sent_success: "Your application has been submitted.",
    coop_my_applications: "My Applications",
    coop_application_date: "Application Date",
    coop_status_in_review: "Under Review",
    coop_upload_document: "Upload Document",
    coop_documents: "Documents",
    coop_documents_saved_success: "Your documents have been saved.",
    coop_career_counseling: "Career Counseling",
    coop_counselor: "Career Counselor",
    coop_appointment_date: "Appointment Date",
    coop_appointment_time: "Appointment Time",
    coop_new_application: "+ New Application",
    coop_delete_application: "Delete Application",
    coop_application_deleted_success: "Your application has been deleted.",
    coop_application_created_success: "Your application has been created successfully.",
    coop_appointment_calendar: "Appointment Calendar",
    coop_create_appointment_request: "Create Appointment Request",
    coop_please_select_slot: "Please select an appointment time.",
    coop_please_select_counselor: "Please select a career counselor.",
    coop_career_counseling_responsible: "Career Counseling Responsible",
    coop_edit_calendar: "Edit Calendar",
    coop_columns: "Columns",
    coop_student_group: "Student Group",
    coop_faculty: "Faculty",
    coop_department: "Department",
    coop_program: "Program",
    coop_cooper: "Coop Cooper",

    coop_calendar_updated_success: "Calendar updated successfully.",
    coop_reschedule_success: "Appointment rescheduled successfully.",
    coop_business_point: "Business Point",
    coop_speaker: "Speaker",
    coop_duration: "Duration",
    coop_remaining_quota: "Remaining Quota",
    coop_quick_apply: "Quick Apply",
    coop_please_select_time: "Please select a time slot.",
    coop_business_point_participants: "COOP Business Point Participants",
    coop_new_event: "+ New",
    coop_delete_participation: "Delete Participation",
    coop_delete_business_point: "Delete Business Point",
    coop_participants: "Participants",
    coop_start_date: "Start Date",
    coop_event_updated_success: "Event updated successfully.",
    coop_companies: "Companies",
    coop_company_id: "Company ID",
    coop_company_code: "Company Code",
    company_code: "Company Code",
    coop_staff_count: "Staff Count",
    coop_ads: "Postings",
    coop_application_count: "Application Count",
    coop_total_application_count: "Total Application Count",
    coop_approved_application_count: "Approved Application Count",
    application_count: "Total Applications",
    approved_application_count: "Approved Applications",
    coop_view_applications: "View Applications",
    coop_min_gno: "Min GPA",
    coop_location_type: "Location Type",
    coop_location_type_onsite: "On-site",
    coop_location_type_remote: "Remote",
    coop_location_type_hybrid: "Hybrid",
    coop_posting_content: "Posting Content",
    coop_posting_applications: "Posting Applications",
    coop_min: "Min",
    coop_max: "Max",
    coop_gpa_info: "GPA Info",
    coop_status_reviewing: "Reviewing",
    coop_status_sent_to_company: "Sent to Company",
    coop_status_company_evaluation: "Company Evaluation",
    coop_status_waiting_student_documents: "Waiting Student Documents",
    coop_status_document_review: "Document Review",
    coop_status_position_closed: "Position Closed",
    coop_submit_documents: "Submit for Approval",
    coop_cv: "CV",

    coop_update_document_status: "Update Document Status",
    coop_download_selected_cvs: "Download Selected CVs",
    coop_export_to_excel: "Export to Excel",
    coop_application_status_updated_success: "Application status has been updated.",
    coop_approval_email_note: "If approved, the acceptance letter will be sent by email.",
    coop_survey_note: "If the internship period is over and attendance is confirmed, a mandatory survey will appear.",
    coop_add_cv: "Add CV",
    coop_cv_name: "CV Name",
    coop_cv_file: "CV File",
    current_file: "Current File",
    coop_cv_added_success: "CV added successfully.",
    coop_events: "COOP Events",
    coop_event_name: "Event Name",
    coop_event_type: "Event Type",
    coop_event_time: "Time",
    coop_event_format: "Event Format",
    coop_event_join: "Join",
    coop_event_joined_success: "You have successfully joined the event.",
    coop_event_management: "COOP Event Management",
    coop_event_new: "New Event",
    coop_event_type_seminar: "Seminar",
    coop_event_type_workshop: "Workshop",
    coop_event_type_webinar: "Webinar",
    coop_event_view_applications: "View Applications",
    coop_event_delete: "Delete Event",
    classroom_matrix:"Classroom Matrix",
    coop_event_deleted_success: "Event deleted successfully.",
    coop_event_applications: "Event Applications",
    coop_event_approve_all: "Approve All",
    coop_event_approve_all_confirm: "All applications will be approved. Are you sure?",
    coop_event_approve_selected: "Approve Selected",
    coop_event_approve_selected_confirm: "Selected applications will be approved. Are you sure?",
    coop_event_apply_confirm: "Are you sure you want to apply for this event?",
    reject_reason: "Rejection Reason",
    coop_event_delete_application: "Remove Participation",
    coop_advisor_unavailabilities: "Advisor Unavailability Management",
    coop_advisor_add_unavailability: "Add Unavailable Date",
    coop_mark_unavailable: "Mark Unavailable",
    coop_mark_unavailable_confirm: "Selected date will be marked as unavailable. Are you sure?",
    coop_advisor_unavailability_delete_confirm: "Selected unavailable date will be removed. Are you sure?",
    coop_advisor_appointments: "Advisor Appointments",
    coop_advisor_appointment_delete_confirm: "Appointment will be cancelled. Are you sure?",
    coop_advisor_appointment_book_confirm: "An appointment will be created for the selected date and time. Are you sure?",
    coop_business_point_events: "Business Point Events",
    coop_speaker_name: "Speaker Name",
    coop_event_date: "Event Date",
    coop_start_time: "Start Time",
    coop_end_time: "End Time",
    coop_slot_duration: "Slot Duration (Minutes)",
    coop_new_business_point_event: "Add New Event",
    coop_edit_business_point_event: "Edit Event",
    coop_delete_business_point_event_confirm: "This event will be deleted. Are you sure?",
    coop_business_point_applications: "Business Point Applications",
    coop_business_point_application_delete_confirm: "This application will be deleted. Are you sure?",
    coop_view_cv: "View CV",
    coop_event_application_delete_confirm: "This application will be deleted. Are you sure?",
    coop_student_bans: "Student Bans",
    coop_new_student_ban: "Add Student Ban",
    coop_delete_student_ban_confirm: "This ban will be removed. Are you sure?",
    coop_ban_reason: "Ban Reason",
    coop_ban_type: "Ban Type",
    coop_banned_by: "Banned By",
    coop_ban_list: "Application Ban List",
    coop_ban_list_add_student: "Add student number",
    coop_ban_list_remove_student: "Remove student number",
    coop_ban_list_enter_student_number: "Please enter a student number.",
    coop_ban_list_add_success: "Student number added to the ban list.",
    coop_ban_list_remove_success: "Student number removed from the ban list.",
    coop_ban_list_remove_all_confirm: "All student numbers will be deleted. Are you sure?",
    coop_ban_list_remove_all_success: "All student numbers have been deleted.",
    work_end_date: "Work End Date",
    leaving_student_number: "Leaving Student Number",
    leaving_student_number_from_system: "Get Leaving Student Number From System",
    count: "Count",
    count_number: "Sequence Number",
    citizenship_exit_date: "Date Of Renouncing Citizenship",
    citizenship_registration_date: "Citizenship Registration Date",
    create_new_examination: "Create New Examination",

    countries: "Countries",
    country: "Country",
    country_code: "Country Code",
    country_id: "Country",
    covid_compensation_certificate: "COVID Compensation Certificate",
    course: "Course",
    course_import_text:
        "Code, Name, Name EN,Name TR, Credit, Practical Credit, Teoric Credit, Lab Credit, Ects Credit, Type, Language, Faculty Code, Department Code, Program Code,Active Status,Grading Scale",
    course_merge_section: "Course Merge",
    course_application_evaluation: "Course Application Evaluation",
    course_code: "Course Code",
    course_coordinator: "Course Coordinator",
    course_count_to_take: "Course Count To Take",
    course_detail_title: "Course Information",
    course_field_is_required: "Course Field Is Required",
    course_grade_entry_report: "Course Based Grade Entry Report",
    course_id: "Course Id",
    course_language: "Language of Instruction",
    course_name: "Course Name",
    course_pool_err: "The Course is available in the Elective Pool",
    course_price: "Course Price",
    course_registration: "Course Registration",
    course_registration_semester: "Course Registration Period",
    course_registration_type: "Course Registration Type",
    course_schedule: "Course Schedule",
    course_update_option_1: "Apply to All Students",
    course_update_option_2: "Apply to Continuing Students",
    course_update_option_3: "Apply to Graduates",
    course_schedule_format: "Course Code",
    course_schedule_from_draft: "Course_Schedule_From_Draft",
    course_schedule_will_be_created_from_draft:
        "Course Schedule Will Be Created From Draft",
    course_status: "Course Status",
    course_transfer: "Course Transfer",
    course_transfer_guide: "Course Transfer Guide",
    course_transfer_history: "Course Transfer History",
    course_transfer_evaluation: "Course Transfer Evaluation",
    course_transfer_success_text: "Your Course Transfer Request  Success Text",
    course_transfer_verify_text: "Course Transfer Verify Text",
    course_transfers_form: "Application Form for Course Transfer",
    course_type: "Course Type",
    course_update_type: "Course Update Type",
    courseprerequisites: "Course prerequisites",
    courses: "Courses",
    courses_you_have_taken_so_for: "Courses You Have Taken So For",
    course_and_slot_logs: "Course and Slot Logs",
    create: "Create",
    create_classes: "Create Classes",
    create_certificate: "Create Certificate",
    create_document: "Create Document",
    create_pilotage_fee: "Create Pilotage Fee",
    create_proforma_invoice: "Create Proforma İnvoice",
    create_student_semesters: "Create Student Semesters",
    create_student: "Create Student",
    created_at: "Created At",
    created_by: "Created By",
    creating_fykk_template: "Creating FYKK Template",
    creating_microsoft_teams_group: "Creating a Microsoft Teams Group",
    credit: "Credit",
    creating_a_thesis_section: "Creating a Thesis Section",
    course_code1: "Course Code",
    control_building: "Control Building",
    course_exam_type: "Course/Exam Type",
    creation_date: "Creation Date",
    credit_card: "Credit Card",
    credit_card_info: "Credit Card Info",
    credit_card_name_surname: "Name on Credit Card",
    credit_card_number: "Credit Card Number",
    credit_limit: "Credit Limit",
    credit_limit_control_report: "Credit Limit Control Report",
    credit_price: "Credit Price",
    create_paid_ones: "Create Paid Ones",
    create_report: "Create Report",
    credit_x: "{credit} Credit(s)",
    credit_student_report: "Course Credit Report",
    creditpayments_report: "Credit Payments Report",
    credits_attempted: "Credits Attempted",
    credits_earned: "Credits Earned",
    criteria_filter: "Criteria Filter",
    current_city: "Current City",
    current_district: "Current District",
    current_password: "Current Password",
    currency: "Currency",
    currency_rate: "Currency Rate",
    current_section: "Current Section",
    curriculum: "Curriculum",
    curriculums: "Curriculums",
    curriculum_credits: "Curriculum Credits",
    curriculum_ects_credit: "Curriculum Ects Credit",
    customer: "Customer",
    customer_budgets: "Customer Budgets",
    customer_budget_information: "Budget Information",
    customer_budget_payment: "Customer Budget Payments",
    customer_group: "Customer Group",
    customer_type: "Customer Type",
    cut_rate: "Cut Rate",
    disabled_paths: "Hidden Pages",
    character_limit_500: "Character limit is 500.",
    created_at_start: "Created At Start",
    created_at_end: "Created At End",

    // D
    do_you_think_to_do_master_in_corp: "Would you like to pursue a Master's degree at the institution?",
    do_copy: "Copy",
    draw_signature: "Draw Signature",
    download_excel_template: "Download Excel Template",
    download_excel_report: "Download Excel Report",
    disability_status: "Disability Status",
    max_duration_information_for_advisor: "Max Duration Information for Advisor",
    dormitory_application_form: "Dormitory Application Form",
    documents_approved: "Documents Approved",
    documents_waiting: "Documents Waiting",
    document_upload: "Document Upload",
    document_select: "Document Select",
    document_no: "Document No",
    document_download: "Document Download",
    document_number_you_want_to_add: "Document Number you want to add",
    dashboard: "Dashboard",
    dashboard_last_updated: "Last updated",
    data: "Data",
    daily_attendances_attendance_report: "Daily Attendance report",
    data_from_system_control: "Data From System Control",
    date_info: "Date Information",
    date_of_document: "Date of Document",
    date: "Date",
    date_between: "Date Range",
    time_between: "Time Range",
    date_of_birth: "Date of Birth",
    day: "Day",
    day3: "3 Days",
    day15: "15 Days",
    daily_attendance_entry: "Daily Attendance Entry",
    daily_attendance_hours: "Daily Attendance Hours",
    daily_attendance_detail: "Daily Attendance Detail",
    day_interval: "Day Interval",
    dean: "Dean",
    disability_information: "Disability information",
    dean_name: "Name of Dean",
    dean_title: "Title of Dean",
    dean_title_en: "Title of Dean",
    death_status: "Death Status",
    debt: "Debt",
    decision: "Decision",
    decision_date: "Decision Date",
    decision_number: "Decision Number",
    decline: "Reject",
    declined_reason: "Declined Reason",
    decline_reason: " Reason for Rejection",
    declined: "Declined",
    declined_academic_unit_office: "Declined Academic Unit Office",
    definitive_registration_information: "Final Registration Information",
    degree_of_proximity: "Degree of Proximity",
    delay: "Delay",
    delay_end_date: "Delay End Date",
    delete_student_number: "Delete Student Number",
    delay_1: "Delay",
    deliverer: "Deliverer",
    deliver_timeout: "Is there a timeout?",
    delivery_type: "Delivery Type",
    deliver_reservation: "Deliver Reservation",
    departmental_elective_ects_credit: "Departmental Elective ECTS Credit",
    delete: "Delete",
    delete_student: "Delete Student",
    delete_student_response: "Delete Student Response",
    delete_all: "Delete All",
    delete_infirmary_user: "Delete Patient Information",
    default: "Default",
    delete_all_students: "Delete All Students",
    delete_empty_summer_student_semester: "Delete Empty Summer Student Semester",
    default_role_changed: "Default role changed",
    department_applied_bau: "Department Applied of Bahçeşehir University",
    dep_course_count: "Dep Course Count",
    dep_course_credit: "Dep Course Credit",
    dep_course_ects_credit: "Dep Course Ects Credit",
    department: "Department",
    department_code: "Department Code",
    department_codes: "Department Codes",
    document_request_info_text1: "Dear Student,\n" +
        "You can submit your document requests by selecting the relevant criteria below and clicking the “Save” button.\n" +
        "After your request is forwarded to the Student Affairs Office, you can track its status from the “My Requests” menu. Once the status of your document appears as “Ready,” you may collect the physical copy from the Student Affairs Office.\n" +
        "Your document will be prepared and delivered to you as soon as possible.\n" +
        "Thank you for your understanding",
    department_name: "Department Name",
    device_id: "Device ID",
    did_not_answer: "Did Not Answer",
    diagnosis: "Diagnosis",
    departments: "Departments",

    detail: "Detail",
    details: "Details",
    detailed_monthly_collection_report: "Detailed Monthly Collection Report",
    denied: "Denied",
    died: "Died",
    Diploma: "Diploma",
    diploma_annexes: "Diploma Supplement",
    diploma_ebys_send: "Diploma EBYS Send",
    diploma_date: "Diploma Date",
    diploma_information: "Diploma Information",
    diploma_name: "Diploma Name",
    diploma_supplement_6_1_dates: "Diploma Supplement 6.1 Dates",
    diploma_name_en: "Diploma Name (EN)",
    diploma_notebook: "Diploma Notebook",
    diploma_number: "Diploma Number",
    diploma_number_from_system: "Get Diploma Number from System",
    diploma_point: "Diploma Grade",
    diploma_status: "Diploma Status",
    diploma_supplement: "Diploma Supplement",
    diploma_supplement_number: "Diploma Supplement Number",
    diploma_title: "Diploma Title",
    diploma_title_en: "Diploma Title (EN)",
    diploma_supplement_6_1: "Diploma Supplement 6.1",
    diploma_supplement_status: "Diploma Supplement Status",
    disability_rate: "Disability Rate",
    disability_type: "Type of Disability",
    discharge_report_for_those_who_have_not_enrolled_in_courses: "Discharge Report for Those Who Have Not Enrolled in Courses",
    disciplinary_committee_decision: "Disciplinary Committe Decision",
    discipline_follow: "Discipline Follow",
    different_number: "Different Number",
    discipline_process: "Discipline Process",
    discipline_registry: "Discipline Registry Document",
    disciplinary_action: "Student has disciplinary action.",
    discount: "Discount",
    discount_amount: "Discount Amount",
    discount_rate: "Discount Rate",
    dispatch_postponement_certificate: "Dispatch Postponement Certificate",
    display_systems: "Display Systems",
    distance_sales_agreement: "Distance Sales Agreement",
    district: "District",
    district_code: "District Code",
    district_name: "District Name",
    districts: "Districts",
    directors_order: "Directors Order",
    dgs: "DGS",
    dgs_e: "DGS EK",
    make_application: "Make an Application",
    do_cancel: "Cancel",
    do_cancel_proccess: "Do Cancel Process",
    do_payment: "Do_Payment",
    do_withdraw: "Withdraw",
    do_you_have_language_proficiency:
        "Do you have language proficiency certificate?",
    do_you_have_language_proficiency_missing:
        "Request Exemption from English Preparatory Program",
    do_you_verify_email: "Would you like to update your e-mail?",
    do_you_verify_mobile_no:
        "Would you like to update your mobile phone number?",
    do_you_want_to_close_the_form_with_the_selected_interview_result:
        "Do you want to close the form with the Selected Interview Result?",
    do_you_want_to_complete_registration:
        "Do you want to complete registration?",
    do_you_want_to_print_receipt: "Do you want to print the receipt?",
    document: "Document",
    download_back: "Download Back",
    download_front: "Download Front",
    do_cancel_process: "Do Cancel Process",
    document_add: "Add Document",
    document_duae_date: "Date to Bring the Document",
    document_due_date: "Document Due Date",
    document_draft: "Document Draft",
    document_edit: "Edit Document",
    document_is_deleted: "Document is Deleted",
    document_number: "Document Number",
    registration_completed_certificate: "Registration Completed Certificate",
    file_name_registration_completed_certificate: "Registration_Completed_Certificate",
    minor_high_honor_certificate: "Minor Certificate High Honor",
    file_name_minor_high_honor_certificate: "Minor_Certificate_High_Honor",
    document_request: "Document Request",
    doctor:"Doctor",
    dr_lecturer_appointment_date: "Dr Lecturer Appointment Date",
    download_front_and_back:"Download front and back",
    document_request_cancel_statement:
        "Your Document Request Will Be Canceled! Do you confirm?",
    document_request_title: "Document Request Title",
    document_registrar_behalf: "Document Registrar Behalf",
    document_registrar_title_behalf: "Document Registrar Title",
    document_registrar_title_en_behalf: "Document Registrar Title (EN)",
    document_registrar_behalf_start_date: "Document Registrar Behalf Start Date",
    document_registrar_behalf_end_date: "Document Registrar Behalf End Date",
    document_requests_title: "Document Requests Title",
    document_settings: "Document Settings",
    document_show: "Show Document",
    document_status: "Document Status",
    document_title: "Document Template",
    document_type: "Document Type",
    document_type_id: "ID",
    document_type_name: "Document Name",
    documents: "Documents",
    documents_are_required: "Documents are required!",
    documents_upload_pending: "You can continue your application by uploading documents",
    documents_university: "The university to which the documents belong",
    domestic: "Domesstic",
    domestic_application: "Domestic Application",
    double_major_application: "Double Major Application",
    double_major_application_quotas: "Double Major Application Quotas",
    double_major_applications: "Double Major Applications",
    double_major_application_start: "Double Major Application Start",
    double_major_termination_report: "Double Major Termination Report",
    double_major_yok_report: "Double Major YOK Report",
    download: "Download",
    download_data: "Download Data",
    download_ticket: "Download Ticket",
    download_photos: "Download Photos",
    download_report: "Download Report",
    download_result_file: "Download Result File",
    down_payment_rate: "Down Payment Rate",
    draft_info: "Draft Information",
    drop_file: "Drop File Here",
    due_date: "Due Date",
    due_date_end: "Due Date End",
    due_date_start: "Due Date Start",
    duration: "Duration",
    document_not_found: "Document Not Found",
    delete_file_upload_again: "Delete the file and upload it again",
    data_filter: "Data Filter",
    download_file: "Download File",
    download_annex: "Download Annex",
    document_images: {
        favicon: " Application Icon",
        "document-logo": "Document Logo",
        background: "Login Page Background",
        logo: "Login Page Logo",
        "menu-logo": "Menu Logo",
    },
    document_barcode_no: "Document Barcode No",
    duration_of_application: "Duration of Application",

    // E
    exam_placement_type: "Placement Type",
    early_payment_report: "Early Payment Report",
    education_credits_report: "Education Credits Report",
    exam_date_enter: "Exam Date Enter",
    exam_info_enter: "Exam Info Enter",
    exchange_students: "Exchange Students",
    exchange_student_filsize_alert: "NOTE: Please upload the Learning Agreement after all the signatures are completed.",
    exchange_student_contact_info: "You may send urgent inquiries via email to bauexchange@int.bau.edu.tr",
    exchange_student_app_approve: "I have read and accept the above information.",
    exchange_student_erasmus_processing_consent: "I consent to the processing of the personal information I have shared with Bahçeşehir University as part of my Erasmus application for the purpose of evaluating my application.",
    exchange_student_world_exchange_consent: "I consent to the processing of the personal information I have shared with Bahçeşehir University as part of my World Exchange application for the purpose of evaluating my application.",
    exam_result: "Exam Result",
    exam_hour: "Exam Hour",
    exam_place: "Exam Place",
    exam_definitions: "Exam Definitions",
    expiration_date: "Expiration Date",
    extended_until: "Extended Until",
    extra_payment: "Extra Payment",
    executor: "Executor",
    exam_score_detail: "Exam Score Detail",
    excluded_registration_academic_years: "Excluded Registration Academic Years",
    estimate_status: "Estimate Status",
    except_roles: "Except Roles",
    enable_editing: "Enable editing",
    close_editing: "Close Edit",
    exempt: "Exempt",
    exemptionStatus: "Exemption Status",
    earned_degree: "Earned Degree",
    e_registration_system: "Online Registration System",
    e_registration_system_info: "* If you have a Leave Of Absence request, your request will be created when you complete your registration. You can check your request status from the 'Leave Of Absence' tab in the 'My Requests' application by logging into UMIS with your user name and password.",
    early_discount_rate: "Early Discount Rate",

    ebys_type_id: "EBYS Type Document ID",
    ebys_status_waiting: "Waiting",
    ebys_status_ready: "Ready",
    ects: "ECTS",
    ects_credit: "ECTS Credit",
    ects_student_report: "ECTS Student Report",
    ects_credit_of_uncompleted_slots: "ECTS Credit of Uncompleted Slots",
    ects_credits_attempted: "ECTS Credits Attempted",
    ects_credits_earned: "ECTS Credits Earned",
    edit_classrooms: "Edit Classrooms",
    edit_due_date: "Edit Due Date",
    edit_end_date: "Edit End Date",
    edit_grade_conversion: "Edit Grade Conversiom",
    edit_class_information: "Edit Class information",
    edit_option: "Edit Option",
    edit_payment: "Edit Payment",
    edit_preference: "Edit Preference",
    edit_question: "Edit Question",
    edit_section: "Edit Section",
    edit_slot: "Edit Slot",
    edit_logo: 'Edit Logo',
    education: "Education",
    exam_report: "Exam Report",
    exam_envelope_delivery_status: "Exam Envelope Delivery Status",
    exam_report_all_section: "Exam Report (All Section)",
    exam_report_list: "Exam Report List",
    exchange_university_name: "Exchange University Name",
    education_and_exam_info: "Education And Exam Info",
    education_and_exam_reqired: "Education And Exam Regired",
    education_credit: "Education Credit",
    education_delete_info:
        "You are about to delete the selected Education Information. Do you want to continue processing?",
    education_info: "Education Information",
    education_information: "Education Information",
    education_information_reporting: "Education Information Reporting",
    education_line_cancel: "Click to remove from Education Information.",
    education_status: "Education Status",
    educator_report: "Educator Report",
    examination_report: "Examination Report",
    effect_gpa: " Does it Effect the CGPA?",
    effect_ratio: "Effect Ratio",
    egovernment_code: "E-Government Code",
    ekc_certificate: "EKC Certificate",
    elective_pool: "Elective Pool",
    elective_pool_id: "Elective Pool ID",
    elective_pools_course_delete_confirm_text:
        "Elective Pools Course Delete Confirm_Text",
    elective_pools_delete_confirm_text: "Elective Pools Delete Confirm Text",
    elective_pools_form: "(Form for) Adding Elective Pool Courses ",
    elective_pools_info: "Elective Pool Information",
    elective_pools_report: "Elective Pools Report",
    elective_pools_store_confirm_text: "Elective Pools Store Confirm Text",
    elective_pools_title: "Elective Pool",
    elective_pools_update: "Elective Pools Update",
    email: "E-Mail",
    email_address: "E-Mail Address",
    email_of_advisor: "E-mail Of Advisor",
    email_placeholder: "Enter Your E-Mail Address",
    email_update: "Update E-Mail",
    email_verify_not: "Verify your E-Mail Address!",
    email_send: "E-Mail Send",
    emergency_contact_txt: "Person to Contact in Emergency",
    emergency_person: "Emergency Contact Person's Name",
    emergency_person_phone: "Emergency Contact Person's Phone Number",
    employment_certificate: "Employment Certificate",
    empty_classrooms: "Empty Classrooms",
    empty_data_on_table: "Fill the empty fields in the Table!",
    end: "End",
    end_date: "End Date",
    end_date_cannot_be_earlier_than_start_date: "End date cannot be earlier than start date.",
    end_time: "End Time",
    end_kilometer: "End Kilometer",
    endorse: "Endorse",
    english: "English",
    english_education_percentage: "English Education Percentage",
    enter_attendance: "Enter Attendance",
    enter_explanation: "Enter Explanation",
    enter_value: "Enter Value",
    entry_document: "Entry Document",
    entry_score: "Entry Score",
    entry_section: "Entry Section",
    entry_note: "Entry Note",
    epayment: "Online payment",
    epayments_report: "Online Payments Report",
    online_payment_agreement: "Online Payment Agreement",
    error: "Error",
    error_min_0_max_100: "The value you enter must be between 0-100.",
    equal_weight_score: "Equally Weighted",
    equivalence_status: "Equivalence Status",
    evaluation: "Evaluation",
    evaluations: "Evaluations",
    evaluation_type: "Exam ",
    events: "Events",
    event_announcement: "Event Announcement",
    event_owner: "Event Owner",
    edit_patient_information: "Edit Patient Information",
    event_type: "Event Type",
    event_name: "Event Name",
    event_format: "Event Format",
    event_start_date: "Event Date",
    event_end_date: "Event End Date",
    event_location: "Event Location",
    event_registration_form: "Event Registration Form",
    event_ticket_details: "Event Certificate Details",
    external_participation: "External Participation",
    exam: "Exam",
    examinations: "Examinations",
    exam_application_start_date: "Application Start Date for Exam",
    exam_application_to_date: "Application Deadline for Exam",
    exam_averages: "Exam Averages",
    exam_capacity: "Exam Capacity",
    exam_date: "Exam Date",
    exam_delete_info:
        "You are about to delete the selected exam Information. Do you want to continue processing?",
    exam_effect_ratio: "Exam Effect Ratio",
    exam_info: "Exam Info",
    examination_date: "Medical examination date",
    email_pin_code_message: "Please enter the PIN code that was sent to your email address.",
    exam_line_cancel: "Click to remove from Exam Information.",
    exam_method: "Exam Method",
    exam_datetime: "Exam Datetime",
    exam_code: "Exam Code",
    exam_name: "Exam Name",
    exam_parts: "Parts of the Exam",
    exam_schedule1: "Exam Schedule",
    exam_schedule: "Exam Schedule",
    exam_schedule_id: "Exam Schedule ID",
    exam_schedule_format: "Course Code",
    exam_schedule_available_time:
        "Finding Available Time for the Exam Schedule",
    exam_score: "Exam Score",
    exam_status_report: "Exam_Status_Report",
    exam_type: "Exam Type",
    exam_time: "Exam Time",
    exams_to_take: "Exams to take",
    exam_definition: "Exam Definition",
    exam_info_download: "Exam Info Download",
    exam_info_upload: "Exam Info Upload",
    exam_result_download: "Exam Result Download",
    exam_result_upload: "Exam Result Upload",
    exam_result_calc: "Exam Result Calculate",
    exams: "Exams",
    excused_absence_report: "Detailed Excuse Report",
    excel: "Excel",
    excel_file: "Excel File",
    excel_format: "Excel Format",
    excel_export: "Excel Export",
    excel_export_items: "Excel Export Fields",
    exception_logs: "Exception Logs",
    excluded_program_codes: "Excluded Program Codes",
    excluded_registration_types: "Excluded Registration Types",
    excuse_file: "Excuse File",
    excuse_letter: "Excuse Letter",
    excuse_start_date: "Excuse Start Date",
    excuse_end_date: "Excuse End Date",
    expand_all: "Expand All",
    expiry_date: "Expiry Date",
    expiry_month: "Expiry_Month",
    expiry_year: "Expiry Year",
    explanation: "Explanation",
    explanation_en: "Explanation En ",
    extend: "Extended",
    external_application: "Interagency",
    extra_installment: "Extra Installment",
    extra_time: "Extra Time",
    exam_overlap_report: "Exam Overlap Report",
    error_student_status_not_contiune:
        "You cannot log in to this page because student status is not ongoing.",
    excel_import_template: "Excel Import Template",
    equivalent_course: "Equivalent Course",
    end_of_semester_absence_report: "Student End-of-Term Attendance Report",

    // F
    first_password_get: "Get Your First Password",
    faculties: "Faculties",
    faculty: "Faculty",
    faculty_grade_entry_report: "Faculty Based Grade Entry Report",
    faculty_council_order: "Faculty Council Order",
    faculty_course_grade_entry_report:
        "Faculty Course Based Grade Entry Report",
    faculty_applied_bau: "Faculty Applied of Bahçeşehir University",
    faculty_code: "Faculty Code",
    faculty_code_name: "Faculty Code / Name",
    faculty_name: "Faculty Name",
    faculty_name_en: "Faculty Name (EN)",
    faculty_of_choice: "Faculty Of Choice",
    faculty_rank: "Faculty Ranking",
    faculty_comparison_report: "Faculty Comparison Report",
    failed_data_count: "Failed Data Count",
    failed_course_report: "Failed Course Report",
    fall: "Fall",
    fall_and_spring: "Fall and Spring",
    fall_credit: "Fall Credit",
    false: "False",
    family: "Family",
    family_info: "Family Information",
    family_information: "Family Information",
    fast_transactions: "Fast Transactions",
    father: "Father",
    father_gsm: "Father's Gsm",
    father_job: "Father's Job",
    faculty_of_registration: "Faculty of registration",
    father_name: "Father Name",
    father_name_placeholder: "Enter father's name",
    fathers_education: "Father's Educational Status",
    fathers_gsm: "Father's Gsm",
    fathers_job: "Father's Job",
    fees_and_installments: "Fees and Installments",
    female: "Female",
    fashion_design_applications: "Fashion Design Applications",
    fee: "Fee",
    fetch_document: "Fetch Document",
    fields_are_reqired: "Fill out all Fields marked (as) Required",
    file: "File",
    field_program: "Field/Programme",
    file_name_acceptance_letter: "Acceptance_Letter",
    file_name_course_schedule: "Course Schedule",
    foreign_student_community_internship_assignment: "Foreign Student Community Internship Assignment",
    file_name_dispatch_postponemen: "dispatch-postponemen",
    file_name_diploma: "Diploma File",
    financial_documents: "Financial Documents",
    finalize: "Finalize",
    front_side: "Front Side",
    finalize_grade_cancel: "Cancel Finalization",
    finalize_grades: "Finalize Grades",
    grade_evaluation_list: "Grade Evaluation List",
    grade_evaluation_report: "Grade Evaluation Report",
    pdf: "PDF",
    final_confirmation_date: "Final Confirmation Date",
    final_confirmation_time: "Final Confirmation Time",
    finalize_na_grades: "Finalize NA Grades",
    file_name_diploma_annexes: "Diploma Annexes",
    file_name_ekc_certificate: "EKC_Certificate",
    file_name_english_placement_exam: "english-placement-exam",
    file_name_exam_schedule: "exam_-chedule",
    file_name_language_proficiency: "language-proficiency",
    file_name_military_status: "military-status",
    file_name_new_password: "new-password",
    file_name_prep_grade_certificate: "Prep_Grade_Certificate",
    file_name_prep_transcript: "prep-transcript",
    fee_disclaimer_message: "This is an estimated fee; the actual amount may vary at the time of registration. Once your application is approved by the academic department, you must complete your payment at <a href='https://umis.bau.edu.tr/epayment' target='_blank' class='text-primary'>https://umis.bau.edu.tr/epayment</a>.",
    file_name_school_certificate: "school-certificate",
    file_name_student_certificate: "student-certificate",
    transfer_certificate: "Transfer Certificate",
    file_name_visa_support_letter: "visa-support-letter",
    file_name_student_information_system: "student-information-system",
    file_name_transcript: "transcript",
    file_name_user_guide: "user-guide",
    file_name_welcome_letter: "welcome-letter",
    file_upload_not_1: "Send English Proficiency Certificates to",
    file_upload_not_2: "Students who wish to freeze registration?",
    file_upload_not_3:
        "<a>ekayit@bau.edu.tr</a> adresinden iletişime geçebilirsiniz.",
    files: "Files",
    fee_simulation: "Fee Simulation",
    fill_at_least_one_field: "Fill at least one field",
    filter1: "Filter",
    findings: "Findings",
    filter: "Filter",
    filter_type: "Filter Type",
    filter_value: "Filter Value",
    final_letter_grade: "Final Letter Grade",
    final_grade_entry: "Final Grade Entry",
    finalize_the_application: "Finalize Application",
    final_grades: "FINAL GRADES",
    final_exam: "FINAL Exam",
    finance_offset: "Finance Offset",
    finance_reports: "Finance Reports",
    finance_supervisor_reports: "Supervisor Reports",
    find: "Find",
    find_student: "Find Student",
    finished_class: "Finished Class",
    first_attempt_certificate: "First Attempt Certificate",
    first_installment: "First İnstallment",
    first_student_count: "Number of First-Time / New Students",
    first_registration: "First Registration",
    force_education_price: "Force Education Price",
    foreign_document_number: "Foreign Identification Number",
    foreign_document_type: "Foreign Document Type",
    foreign_status: "Foreign Status",
    foreign_student: "International Student",
    foreign_student_q: "Foreign Student?",
    foreign_student_credentials: "International Student Credentials",
    foreign_student_identity: "International Student ID",
    foreign_participant: "Foreign Participant",
    forgot_my_password: "I Forgot My Password",
    format: "Format",
    friday: "Friday",
    from_score: "From Score",
    from_email: "From E-Mail",
    from_point: "Ceiling Score",
    full_name: "Full Name",
    full_time: "Full Time",
    full_scholarship_students_enroll: "Full Scholarship Students Enroll",
    future_payment: "Postponing Payment Due Date",
    future_ai_summit: "Future AI Summit'25 April 16-17",
    future_ai_summit_title: "Future AI Summit'25",
    fykk_template: "Fykk Template",
    future_ai_summit_team: "Future AI Summit Organization Team",
    free: "Free",
    fetch_data: "Fetch Data",
    flight_information: "Flight Information",
    from_date: "From Date",

    // G
    gateway: "Gateway",
    guest: "Guest",
    guardian_national_id: "Guardian National Id",
    guardian_mobile_tel: "Guardian Mobile Tel",
    guest_student_application: "Guest Student Application",
    graduate_card_status: "Graduate Card Status",
    graduate_email_status: "Graduate Email Status",
    graduate_full_scholarship_ratio_report: "Graduate Full Scholarship Ratio Report",
    graduate_bachelor_program: "Graduate Bachelor Program",
    graduate_phd_program: "Graduate Phd Program",
    graduate_master_program: "Graduate Master Program",
    graduate_high_school_name: "Graduate High School Name",
    graduate_high_school_code: "Graduate High School Code",
    graduation_document_number: "Graduation Document Number",
    graduate_app_info: "<h5>Attention to Applicants for Master's Programs</h5>" +
        "<p>Applications to graduate programs offered under the Graduate Education Institute are submitted through the online application system." +
        " Candidates must carry out the application process in coordination with the institute.</p>" +
        "<p>In the first stage of the application process, which is the online application, candidates may apply to a maximum of three programs." +
        " It is not mandatory to fill all three preferences. In addition to the first preferred program, applying to two additional programs is at the candidate’s discretion.</p>" +
        "An ALES score is not required for applicants to non-thesis master's programs." +
        " However, candidates who have an ALES score of 85 or above in the relevant score type of the department they apply to may benefit from a 20% ALES achievement scholarship," +
        " which is among the merit-based scholarships offered by the university." +
        "<p>An ALES score is required for applicants to thesis master's programs." +
        " For ALES score criteria, candidates must contact the institute.</p>" +
        "<p>For programs where the language of instruction is English, candidates are required to have valid and up-to-date exam results from TOEFL, YDS, YÖKDİL, or the BAU English Proficiency Exam." +
        " (For score criteria, candidates must contact the institute. The validity period of TOEFL and the BAU English Proficiency Exam is 2 years," +
        " while the validity period of YDS and YÖKDİL exams is 5 years.)</p>" +
        "<p>No English proficiency certificate is required for applications to programs where the language of instruction is Turkish." +
        " However, candidates who have sufficient scores from recognized language proficiency exams may benefit from a 10% language achievement scholarship," +
        " which is among the merit-based scholarships offered by the university.</p>" +
        "<h5>Attention to Applicants for Doctoral Programs!</h5>" +
        "<p>Applications to graduate programs offered under the Graduate Education Institute are submitted through a joint online application system." +
        " Candidates must carry out the application process with the institute affiliated with the program they prefer.</p>" +
        "<p>Candidates applying to doctoral programs under the Graduate Education Institute are entitled to apply to only one program.</p>" +
        "<p>At the application stage for doctoral programs, candidates must meet all required conditions." +
        " Special student status is not applicable during the doctoral application process.</p>" +
        "<p>Candidates who meet all requirements are entitled to take the written scientific examination." +
        " Candidates who successfully pass the written exam will be invited to a verbal interview." +
        " If accepted into the program, they will be eligible for final registration.</p>" +
        "<p><p>Important note:</p> In accordance with the amendments made to the Council of Higher Education (YÖK) Graduate Education and Training Regulation dated February 6, 2013," +
        " the following conditions apply to doctoral program applications:</p>" +
        "<ul><li><u>For candidates applying with a thesis master's degree,</u> an ALES score of at least 60 in the relevant score type" +
        " and a minimum score of 65 in YDS or YÖKDİL (or an equivalent exam) are required.</li></ul>" +
        "<p>Candidates who enrolled in or graduated from a non-thesis master's program before February 6, 2013" +
        " will be subject to the same conditions as candidates applying with a thesis master's degree.</p>" +
        "<p>(See: <a href='http://www.resmigazete.gov.tr/eskiler/2013/02/20130206-10.htm'>http://www.resmigazete.gov.tr/eskiler/2013/02/20130206-10.htm</a>)</p>" +
        "<p><b>NOTE:</b> The criteria for applying to doctoral programs with a bachelor's degree may vary depending on the institute." +
        " Candidates should contact the relevant institute for detailed information.</p>" +
        "<p><b>NOTE:</b> According to institute decisions, ALES and language proficiency score requirements for doctoral programs may vary.</p>",
    graduate_document_no: "Graduate Document No",
    graduate_document_no_placeholder: "Enter Graduation Document Number",
    go_to_payment: "Proceed to Payment and Registration",
    gender: "Gender",
    general: "General",
    general_information: "General Information",
    generate_ticket_discount_codes: "Generate Ticket Discount Codes",
    gep_course_count: "Gep Course Count",
    gep_course_credit: "Gep Course Credit",
    gep_course_ects_credit: "Gep Course Ects Credit",
    get_report: "Get Report",
    gear: "Gear",
    give_exception_payment_approval: "Give Exceptional Payment Approval",
    giveable_roles: "Giveable Roles",
    gna_not_range: "CGPA Grade Range",
    gno: "CGPA",
    gno_between: "GNO Between",
    gno_of_transferred_courses: "CGPA of Adapted Courses",
    gno_simulation: "GNO Simulation",
    gno_carculate: "Calculate CGPA",
    gpa: "GPA",
    go: "Go",
    grade: "Grade",
    grading_scale: "Grade Scale",
    grand_total: "Grand Total",
    graduate_application_evaluation_exam: "Graduate Exam Definition",
    grade_conversion_define_tabel: "Grade Conversion Define Tabel",
    grade_conversion_define_title: "Grade Conversion Define Title",
    grade_conversion_id: "Grade Conversion Id",
    ge_elective_ects_credit: "GE Elective ECTS Credit",
    ge: 'Georgian',
    grade_conversion_info: "Grade Conversion Info",
    grade_conversion_name: "Grade Conversion Name",
    grade_conversion_range_end: "Grade Conversion Range End",
    grade_conversion_range_start: "Grade Conversion Range Start",
    grade_conversion_table_title: "Grade Conversion Table Title",
    grade_conversion_update_title: "Grade Conversion Update Title",
    grade_conversion_update_verify_text: "Grade Conversion Update Verify Text",
    grade_conversion_verify_text: "Grade Conversion Verify Text",
    grade_conversion_verify_text_2: "Grade Conversion Verify Text 2",
    grade_entry: "Grade Entry",
    grading_system_type: "Grading System Type",
    grade_entry_confirmation_modal: "Grade Entry Confirmation Modal",
    grade_id: "Grade İd",
    grade_is_deleted_text: "Grade Is Deleted Text",
    grade_scala: "Grading Scale",
    grade_table_is_empty: "Grade Table Is Empty",
    grade_up_lessons: "Courses to Up Grade CGPA",
    grades: "Grades",
    grading_systems: "Grading Systems",
    grading_system: "Grading System",
    grading_system_id: "Grading System ID",
    graduate_number_of_students_and_collection_report: "Graduate Number of Students and Collection report",
    ge_selective_credit: "GE Selective Credit",
    graduate: "Graduate",
    graduate_requirement_info: "Graduate Requirement Info",
    graduate_card_create: "Graduate Card Create",
    graduate_date_in: "Graduate Date",
    homework_entry: "Homework Entry",
    graduate_email: "Graduate E-mail",
    graduate_application_after_verify_info: "Başvurunuzun herhangi bir sebeple yarım kalması halinde tarafınıza gönderilen SMS Kodu ile <a href=login>Başvuru Güncelleme</a> adresinden başvurunuza devam edebilirsiniz.",
    graduate_application_form: "Graduate Application Form",
    graduate_application_form_update_btn:
        "Graduate Application Form Update Btn",
    graduate_application_yok_statement:
        "(Candidates who graduated from universities abroad can upload their YÖK Equivalency Certificates from the other documents section.)",
    graduate_applications: "Graduate Applications",
    graduate_exam_results: "Graduate Exam Results",
    graduate_date: "Graduate Date",
    graduate_semester: "Graduate Semester",
    graduate_detail_cpga: "Detailed CGPA",
    graduate_application_quotas: "Graduate Application Quotas",
    graduation_certificate: "Graduation Certificate",
    graduation_academic_year: "Graduation (Academic) Year",
    graduation_average: "Graduation Average",
    graduation_credit: "Graduation Credit",
    graduation_date: "Graduation Date",
    graduation_date_between: "Graduation Date Range",
    graduation_decision_date: "Graduation Decision Date",
    graduation_decision_number: "Graduation Decision Number",
    graduation_degree: "Graduation Degree",
    graduation_document_info: "The graduation document number refers to the barcode number located at the top-right corner of the 'Graduation Certificate' that you can obtain from the E-Devlet portal. It can be added to the area shown in the image.",
    graduation_ects_credit: "Graduation ECTS Credit",
    Graduation_GPA: "Graduation GNO",
    graduation_information: "Graduation Information",
    graduate_info: "Graduate Info",
    graduate_period: "Graduate Period",
    graduate_project: "Graduate Project",
    graduation_semester: "Graduation Semester",
    graduation_status: "Graduation Status Check",
    graduation_simulation: "Graduation Simulation",
    graduation_university: "Graduation University",
    graduation_year: "Graduation Year",
    graduationDate: "Graduation Date",
    georgia_address: "Georgia Address",
    graduation_requirements: "Graduation Requirements",
    gross_price: "Gross Price",
    gross_price_certificate: "Gross Price",
    gsm_no: "Gsm No",
    guarantee1: "Guarantee",
    guarantee1_address: "Guarantee Adress",
    guarantee1_national_id: "TC Identity Number of Guarantee",
    guarantee1_phone: "Guarantee Phone",
    guarantee2: "Guarantee",
    guarantee2_address: "Guarantee Adres",
    guarantee2_national_id: "TC Identity Number of Guarantee",
    guarantee2_phone: "Guarantee Phone",
    guarantee: "Guarantee",
    guarantee_address: " Address of Guarantee",
    guarantee_national_id: "TC Identity Number of Guarantee",
    guarantee_phone: "Kefil Phone",
    guide_code: "Guide Code",
    guide: "Guide",

    // H
    have_student_program:
        "There is a student registration. Do not process here.",
    has_english_cert: "Will you apply for exemption from english preparatory program?",
    habits: "Habits",
    calculation_type: "Calculation Type",
    fee_information: "Fee Information",
    has_teams_integration: "Has Teams Integration",
    have_payment_approval: "Payment Approval",
    has_balance: "Has Balance",
    has_payments: "Has Payments",
    healthcare_personnel: "Healthcare Personnel",
    have_you_leave_of_absence_before: "Taken leave of absence before?",
    head_of_department: "Head of Department",
    head_of_program: "Coordinator",
    hall_setup: "Hall Setup",
    have_language_proficiency_certificate: "Have you received a language proficiency certificate?",
    health: "Health",
    health_information: "Health Information",
    hello: "Hello",
    help: "Help",
    hide_details: "Hide Details",
    help_videos: "Help Videos",
    hes_code: "HES Code",
    home_address: "Home Address",
    home_number: "Home Phone Number",
    home_tel: "Home Phone",
    host_university: "Host University",
    horizontal_or_vertical_attended_university:
        "Lateral / Vertical Transfer from Previously Attended University",
    horizontal_or_vertical_attended_university_1:
        "Lateral / Vertical Transfer from Previously Attended University",
    horizontal_or_vertical_coming_from_university:
        "Lateral / Vertical Transfer to the University",
    horizontal_or_vertical_coming_from_university_1:
        "Lateral / Vertical Transfer to the University",
    hour: "Hour",
    hours: "Hours",
    holiday_day: "Holiday Day",
    hybrid: "Hybrid",
    high_school: 'High School',
    high_school_diploma_score: "High School Diploma Score",
    high_school_info: "High School Info",
    high_school_major_type: "High School Major Type",
    high_school_graduate_date: "High School Graduate Date",
    high_honor: "High Honor Process",
    high_honor_status: "Honor Status",
    headers: 'Headers',
    hybrid_statuses: "Hybrid Statuses",
    honour_high_honour_achievement_ranking: "Honour / High Honour Achievement Ranking",
    home_university_name: "Home University Name",
    home_university_country: "Home University Country",
    home_university_faculty: "Home University Faculty",
    home_university_department: "Home University Department",
    home_university_program: "Home University Program",
    home_university_address: "Home University Address",
    high_school_major_type_7: "Fine Arts",

    insufficient_limit: "Insufficient limit",
    institute_approval: "Institute Approval",
    instructionLanguage: "Instruction Language",
    iban: "IBAN number",
    id: "ID",
    identity: "Identity",
    identify: "TC or Passport Number",
    identity_information: "Identity Information",
    identity_card: "Identity Card",
    image_upload: "Image Upload",
    import: "Import",
    import_button: "Import Button",
    import_course_schedule: "Import Course Schedule",
    import_student_club_member_search: "Import Student Club Member Search",
    import_draft: "Import Draft",
    import_exam_schedule: "Import Exam Schedule",
    import_photos: "Import Photos",
    in_class: "Face-to-Face / In Class",
    in_evaluation: "In Evaluation",
    included_registration_types: "Included Registration Types",
    indefinite: "Indefinite",
    info_file: "Information File",
    info_link: "Information Link",
    info_text: "Info Text",
    information: "Information",
    input_type: "Input Type",
    installment: "Installment",
    installment_amount: "Installment Amount",
    is_cgpa_locked: "GNO Unlocked",
    installment_count: "Number of Installments",
    include_graduates: "Include Graduates",
    installment_options: "Installment Options",
    installment_payment: "Installment Payment",
    installment_payment_type: "Installment Payment Type",
    installment_start_date: "Installment Start Date",
    installments: "Installments",
    installments_total: "Sum of Total Installments",
    instructor: "Instructor",
    instructor_can_use: "Can be used by Instrutors",
    instructor_courses_title: "Instructor Courses Title",
    instructor_name: "Name of Instructor",
    instructor_surname: "Surname of Instructor",
    instructors: "Instructors",
    is_cash:"Cash",
    instructor_letter_grade_excel_export:
        "Instructor Letter Grade Excel Report",
    instructor_exam_requests: "Instructor Exam Request Collection",
    instructor_exam_request_admin: "Instructor Exam Data Collection",
    intership_information: "Intership Information",
    invalid_course_coordinator: "Course Coordinator not found",
    invalid_student: "Student not found",
    invalid_value: "Invalid Value",
    invalid_values: "Invalid Values",
    invalid_national_id: "Invalid national id",
    invert: "Invert",
    investigation_report: "Investigation Report",
    invitation_to_the_defense: "Invitation To The Defense",
    individual: "Individual",
    individual_ticket: "Individual Ticket",
    individual_ticket_for: "Individual Certificate for",
    institutional: "Institutional",
    institutional_ticket: "Institutional Ticket",
    invoice1: "Invoice 1",
    illness_information: "Illness information",
    invoice2: "Invoice 2",
    invoice3: "Invoice 3",
    invoice4: "Invoice 4",
    international_student: "Create Student",
    international_curriculum: "International Curriculum",
    invoices: "Invoices",
    invoice_number: "Invoice Number",
    invoice_amount: "Invoice Amount",
    irregular: "Irregular",
    irregular_status: "Irregular Status",
    is_before_undergraduate_transfer:
        "Have you made a horizontal transfer before?",
    is_before_undergraduate_transfer_type:
        "What type of horizontal transition did you do?",
    is_default: "Is it default?",
    is_graduate: "Is it graduate?",
    is_numeric: "Is it numeric?",
    is_paid: "Has it been paid?",
    is_passing: "Is Passing",
    identity_passport_document: "ID Document / Passport Document",
    is_rate: "Is it Rate",
    is_required: "Is it Required?",
    is_multi_selection: "Is it Multi Selection ?",
    is_revert: "Is it revert ?",
    i_approve: "I approve",
    i_not_approve: "I don't approve",
    inbox: "Inbox",
    instructors_letter_grade: "Instructors Letter Grade",
    is_there_a_header: "Is there a Header/Heading",
    is_take_exam: "Is Take Exam",
    is_exam_time_lesson: "Is Exam Time Lesson",
    is_additional_classroom: "Is Additional Classroom",
    is_in_program: "Will it be in the program?",
    invalid_json: "Invalid JSON",

    // J
    job: "Job",
    job_address: "Job Address",
    job_and_contact_info: "Job Contact Info",
    job_corporation: "Job Corporation",
    job_department: "Job Department",
    job_description: "Job Description",
    job_experience: "Job Experience",
    job_experience_desc:
        "(Varsa önceki iş deneyiminiz ile birlikte toplam süre olarak belirtiniz.)",
    job_info: "Job Info ",
    job_prep_student_period_status_create: "Job Prep Student Period Status Create",
    job_information: "Job Information",
    jazz: "Jazz",
    jazz_vocal: "Jazz Vocal",
    job_other: "Job Other",
    job_sector: "Job Sector",
    job_tel: "Job Phone",
    jobs: "Jobs",
    joining_place: "Joining Place",

    // K
    key: "Key Field",
    ky_ratio: "P/R Ratio",
    keyword_1: "Keyword 1",
    keyword_2: "Keyword 2",
    keyword_3: "Keyword 3",
    kvkk_modal_title: 'Clarification Text Regarding Processing of Personal Data',
    kyk_information: "KYK Information",
    kvkk_code: "KVKK Code",
    kvkk_data_approve: "I have read, understood and <strong> accepted the text of the protection of personal data </strong> and express consent.",
    kvkk_content_text: `The purpose of this text is to enlighten you as to how the Data Controller,  ‘Bahçeşehir Accommodation and Tourism Investments Incorporation’/’Bahçeşehir Konaklama ve Turizm Yatırımları Anonim Şirketi’ (“Bahçeşehir Konaklama” or "Şirket")/(“Bahçeşehir Accommodation” or " Company/Incorporation ") processes your personal data.  Subjects regarding the processing of your Personal Data are listed below, under the relevant headings.

    For what purposes and on what legal grounds is my personal data being processed?
    Articles 5 and 6 of the Personal Data Protection Law  (“Kanun”/ “the Law”) establish the legal grounds  for processing of Personal Data. Below we have stated for what purposes we  are processing your personal data and the respective legal grounds for the processes:<br>
    Your personal data are processed in view of the purposes stated below, on the legal grounds that processing personal data is mandatory, in order for the Company to perform its legal obligations as explicitly foreseen in the Laws<br>
    •	Performance of our Company’s legal obligations, upon the request of authorized institutions or organizations or due to our obligations to make the necessary notifications to such institutions (for example, fulfilling the obligation for identity notification regarding the students staying at the Dormitory, within the context of the  Identity Notification Law)
    •	Performance of legal obligations, including invoicing,<br>
    Your personal data are processed for the following purposes, on the legal grounds that processing of personal data belonging to the parties of a contract is necessary, provided that it is directly related to the conclusion or fulfilment of that contract.<br>
    •	Execution of the assignment and admittance procedures of students to the Dormitory,
    •	Establishment of your record for the delivery of accommodation services and meeting our liabilities     arising from the service delivery agreement.,
    •	Collection of dormitory accommodation service  fees<br>
    Your personal data are processed for the following purposes, on the legal grounds that personal data processing is mandatory for the establishment, exercise or protection of any rights.<br>
    •	Protection and exercise of our rights in case of any legal disputes, and execution of legal and disciplinary  procedures.<br>
    Your personal data are processed for the following purposes, on the legal grounds  that  it is mandatory for the legitimate interests of the Company, provided that such processing shall not violate the fundamental rights and freedoms of the data subject.<br>
    •	Implementation of the communication processes; receiving and resolving requests and complaints
    •	Maintaining the security of our dormitories and services; preventing unauthorized  entry and exits,
    •	Ensuring compliance with Company policies and procedures; execution of auditing and management activities.<br>
    Your personal data are processed for the purposes stated below, on condition that you have given explicit consent:<br>
    •	Information regarding personal criminal record and personal health status;
    •	Realizing health and safety controls of students utilizing the accommodation services, administering the assignment and admission procedures of students to the Dormitories and informing the authorized persons, institutions and  organizations.<br>
    Which of my Personal Data are Processed?<br>
    In line with the foregoing purposes, we as ‘Bahçeşehir Accommodation’, process your personal information regarding your identity, communication channels , educational background, accommodation, financial status, information regarding your family, friends and persons to contact in case of emergency situations,  information regarding their residence permits for international students, as well as personal health and criminal record data.
    To whom and for what purposes are my personal data being transferred?<br>
    We share your personal data with our business partners/associates, suppliers and authorized persons, institutions or organizations, in order to realize the purposes under the heading ,“For what purposes and on what legal grounds are my personal data being processed?”, on the legal grounds stated in Articles 5 and 6 of the Law, within the context of the of the rules specified in Articles 8 and 9 of the Law, regarding transfer of personal data.
    How and on what legal grounds are my personal data being collected?<br>
    We collect your personal data by means the following channels and methods<br>
    <strong>Channels for collecting your personal data:</strong> Filling out forms or sharing your personal information with us verbally, in writing or on digital media; your personal data are gathered from the relevant  channels, when you contact us via your phone, e-mail or social media accounts.<br>
    <strong>Methods for collecting your personal data:</strong>  Your personal data are collected partly by  automated means; automated or non-automated means provided that they are part of the data  recording system.

    We are gathering your Personal Data on the basis of the terms specified in Articles 5 and 6 of the Law,  regarding the processing of personal data; on the legal grounds that processing of personal data belonging to the parties of a contract is necessary, provided that it is directly related to the conclusion or fulfilment of that contract; on the legal grounds that personal data processing is mandatory for the establishment, exercise or protection of any rights; on the legal grounds  that  it is mandatory for the legitimate interests of the Company, provided that such processing shall not violate the fundamental rights and freedoms of the data subject; on the legal grounds that processing personal data is mandatory, in order for the Company to perform its legal obligations as explicitly foreseen in the Laws, and we have your explicit consent on condition that you have given explicit consent.


    As the Personal Data Subject, How Can I Exercise my rights?
    Article 11 of the Law establishes the rights of the natural persons whose personal data are being processed. Pursuant to Article 11 of the Law, you are entitled to the following rights:<br>
    •	To learn whether or not your personal data is being processed,
    •	To request further information regarding your personal data that is being processed,
    •	To learn for what purpose your personal data is being processed and whether or not your personal data is being used in line with its intended purpose,
    •	To know the third parties in your country or abroad to whom your personal data has been transferred,
    •	To request rectification of any incomplete or inaccurate processing of your personal data, and to request notification of the third parties to whom your personal data has been transferred, about the corrective actions taken within this context.
    •	To request erasure or destruction of your processed Personal Data upon disappearance of the reasons which require the process, despite being processed under the provisions of the Law; and to request notification of the operations carried out in compliance with this to the third parties to whom your personal data has been transferred.
    •	To object to the occurrence of an unfavourable consequence on your part, due to analysis of your processed personal data by means of exclusively automatic systems,
    •	To request compensation for losses incurred due to unlawful processing of your  personal data<br>
    To communicate your requests regarding your rights, you may apply to the Data Controller by sending a mail to the following address: Abbasağa Mah. Ihlamur Yıldız Cad. No. 8/1A Beşiktaş/İstanbul. You may also use the methods referred to in the “Communiqué on Principles and Procedures for Application to Data Controller 2018”


    Explicit Consent Text Regarding Processing of Personal Data<br>
    In the event that any one of the legal reasons referred to in the “Law” for  processing of your Personal Data does not exist, we as Bahçeşehir Accommodation and Tourism Investments Incorporation (“Bahçeşehir Accommodation), are asking whether we have your explicit consent for processing your personal data or not.
    If you wish to express your Explicit Consent so that we can execute the following personal data  processing procedures, please sign the respective spaces below the texts.  You can withdraw the Explicit Consent you have given at any time, by getting in contact with us.<br>
    <strong>1.</strong>	I hereby express my consent to the processing of my personal health data by Bahçeşehir Accommodation and sharing it with authorized institutions and organizations, for the purposes of realizing health and safety controls of students utilizing the accommodation services, administering the assignment and admission procedures of students to the Dormitories and informing  authorized persons, institutions and  organizations.

    <strong>2.</strong>	I hereby express my consent to the processing of my personal health data by Bahçeşehir Accommodation and sharing it with authorized institutions and organizations, for the purposes of realizing health and safety controls of students utilizing the accommodation services, administering the assignment and admission procedures of students to the Dormitories and informing  authorized persons, institutions and  organizations.`,
    kilometer: "Kilometer",
    // L
    study_rooms: "Study Rooms",
    library_reservation_info_text: "Please select the room you want to work in, then select the date and session (time) in the opened screen to view available seats.",
    total_chairs: "Total Chairs",
    reservation_transaction: "Reservation Transaction",
    reservation_date: "Reservation Date",
    session_seating_plan: "Session Seating Plan",
    occupied: "Occupied",
    no_session_found_for_date: "No session found for this date. Please select another date.",
    this_chair_is_occupied: "This chair is unfortunately occupied during your selected time slot.",
    reservation_confirm: "Reservation Confirmation",
    yes_reserve_for_me: "Yes, Reserve for Me",
    on_date: "on",
    in_session: "session at",
    reserve_chair_number: "Would you like to reserve chair number",
    login_details: "Login Details",
    last_message: "Last message",
    last_meeting_date_from: "Last Meeting Date From",
    last_meeting_date_to: "Last Meeting Date To",
    last_updated: 'Last Updated',

    last_status: 'Last Status',
    last_update_datetime: 'Last Update Date/Time',
    lab: "Lab",
    lab_credit: "Laboratory  (Credits)",
    last_publication_date: "Last Publication Date",
    lab_section: "Lab Section",
    label: "Label",
    label_en: "Label (English)",
    language: "Language",
    language_exam_score: "Language Exam Score",
    language_proficiency_certificate: "Language Proficiency Certificate",
    language_proficiency_certificate_en: "English Language Proficiency Certificate",
    language_proficiency_certificate_tr: "Turkish Language Proficiency Certificate",
    last_approve_date: "Last Approve Date",
    last_course: "Course Previously Taken",
    last_course_registration_semester: "Last Course Registration Semester",
    last_course_registration_year: "Last Course Registration Year",
    last_education_status: "Education Status",
    last_lesson_registration_year: "Last Lesson Registration Year",
    last_process_date: "Last Process Date",
    last_school: "Last School",
    last_school_date_of_graduation: "Last School Date Of Graduation",
    last_school_diploma_number: "Last School Diploma Number",
    last_school_diploma_point: "Last School Diploma Point",
    last_school_registration_date: "Last School Registration Date",
    last_university: "Last University",
    last_update_date: "Last Day for Applications",
    leave_absences: "Leave of Absence",
    leave_of_absence: "Leave Of Absence",
    leave_of_absence_count: "Number of Semesters with Leave of Absence ",
    leave_of_absence_fall: "Leave of Absence  in Fall Semester",
    leave_of_absence_period: "Leave Of Absence Period",
    leave_of_absence_reason: "Reason for Leave of Absence",
    leave_of_absence_description: "Description for Leave of Absence",
    leave_of_absence_semesters: "  Leave Of Absence Semesters",
    leave_of_absence_settings_title: "Leave of Absence Settings",
    leave_of_absence_spring: "Leave Of Absence Spring",
    leave_of_absence_title: "Leave of Absence Request Form",
    leave_of_absence_verify_text: "Leave Of Absence Verify Text",
    lecture_hall: "Lecture Hall",
    leave_of_absence_verify_text_graduate:
        "Do you confirm your leave of absence request for the selected term?\n\n" +
        "Temporary Leave (Registration Freeze) ARTICLE 43-\n\n" +
        "(1) Graduate students with valid and justified reasons may apply for a temporary leave (registration freeze) by submitting supporting documents to the Student Affairs Directorate within the first four weeks of the semester/year. Applications are reviewed with input from the academic department coordinator and finalized by the Graduate School Administrative Board.\n\n" +
        "(2) Applications for temporary leave are evaluated according to the following rules:\n\n" +
        "a) Non-thesis master’s students may suspend their enrollment for a maximum of one semester, thesis-based master’s students for a maximum of two semesters, and doctoral students for a maximum of three semesters due to valid reasons. In exceptional cases, these periods may be extended by a University Administrative Board decision. The period during which a student is on temporary leave is not counted toward the maximum study duration.\n\n" +
        "b) If a student presents a medical report covering an entire semester/year, they may apply for a registration freeze. If the medical condition persists, an extension may be granted upon evaluation by the Graduate School Board. Before resuming studies, students may be required to submit medical clearance confirming their ability to continue their education.\n\n" +
        "c) If a student is conscripted for military service due to an inability to defer enlistment, their enrollment is frozen for the duration of military service.\n\n" +
        "(3) A student who is on temporary leave cannot transfer any courses taken from another institution during this period into their program at the University.\n\n" +
        "(4) Applications for temporary leave due to reasons other than medical conditions or other documented compulsory reasons must be submitted within the first four weeks of the semester/year.\n\n" +
        "(5) If a student is arrested or imprisoned, they may apply for a registration freeze. Upon submission of supporting documents, their enrollment will be suspended until the end of their sentence, including the academic semester/year in which they were incarcerated, subject to the decision of the Graduate School Administrative Board.\n\n" +
        "(6) If a student is forced to interrupt their studies due to a natural disaster, their enrollment may be temporarily frozen until a date deemed appropriate by the Graduate School Administrative Board, provided that the student presents an official document from relevant authorities confirming their status as a disaster victim.\n\n" +
        "(7) Students who freeze their enrollment due to military service, illness, incarceration, or natural disasters are exempt from tuition fees. Students who freeze their enrollment for other reasons must pay 25% of the tuition fee for the period of leave.",
    leave_with_consent: "Leave With Consent",
    leave_with_consent_form: "Leave With Consent Form",
    leave_with_consent_form_student: "Disenrollment Request Form",
    leave_with_consent_reason: "Leave With Consent Reason",
    leave_with_consent_statement1: "Leave With Consent Statement",
    leave_with_consent_statement1_content: "????",
    leave_of_city: "The city where you currently live",
    leave_of_district: "The district where you currently live",
    letter_grade_detail: "Letter Grade Detail",
    line_number: "{number}. line: ",
    library_rooms: "Library Rooms",
    link: "Link",
    language_text: "Have you previously received a Turkish language certificate?",

    leave_of_absence_statement:
        "Do you want to close the form with the selected interview result?",
    leave_with_consent_verify_text: "Leave With Consent Verify Text",
    leaving_academic_year: "Leaving Academic Year",
    leaving_student_report: "Leaving Student Report",
    leaving_date: "Leaving Date",
    leaving_date_between: "Leaving Date Between",
    leaving_information: "Leaving Information",
    leaving_semester: "Leaving Semester",
    lecturer_report: "Lecturer Report",
    lesson_pool: "Elective Course Pool",
    lesson_time: "Class Hours",
    lesson_timetable: "Course Schedule",
    lessons_only_and_delete_students: "Close Courses and Delete Students",
    lessons_only_and_delete_students_and_sms_send:
        "Close Courses Delete Students and Send SMS",
    lessons_we_have_not_taken_before:
        "Courses (You Have ) Not Taken Previously",
    lessons_you_have_taken: "Courses (You Have) Not Completed Successfully",
    letter_grade: "Letter Grade",
    level: "Level",
    last_course_ni_warning: "Your last course will be added to the system as <strong class='text-danger'>NI (Not Included)</strong>. Do you confirm this?",
    list: "List",
    list_of_student_taking_the_course: "List of Students Taking the Course",
    loading: "Loading",
    loading_student_details: "Loading student details...",
    log_detail: "Log File Details",
    log_id: "Log_İd",
    log_message: "Log File Message",
    log_name: "Log File Name",
    log_status: "Log Status",
    login_user: "Login User",
    login_user_id: "login User Id",
    log_time: "Log Time",
    library_chairs: "Library Chairs",
    library_room_id: "Library Room ID",
    log_type: "Log Type",
    login: "Login",
    login_with_student_number: "Login with student number",
    login_with_email_address: "Login with email address",
    logo1: "Logo",
    logout: "Logout",
    local_name: "Local Name",
    local_surname: "Local Surname",
    lookbook_detail: "Lookbook Detail",
    language_key: {
        tr: "Turkish",
        en: "English"
    },
    letter_of_intent: "Letter of Intent",
    letter_of_intent_info1: "Write a letter of intent introducing yourself to this field, stating your goals in choosing the department, and including the work you have done so far.",
    lms: "LMS",
    lms_id: "LMS ID",

    // M
    money_order: "Money order",
    married: "Married",
    mail_order: "Mail Order",
    main_discipline: "Main Discipline",
    main_field: "Main Field",
    major_type: "Major Type",
    major_types: "Types of Major",
    make_payment: "Make Payment",
    make_reservation: "Make Reservation",
    marriage_status: "Marriage Status",
    master_graduation_date: "Master Graduation Date",
    member_at: "Member At",
    music_teories: "Music Teories",
    midterm: "Midterm Exam",
    final: "Final Exam",
    makeup: "Make-up Exam",
    max_ticket_count: "Max Ticket Count",
    make_up_exam: "Make-up Exams",
    make_up_exam_entry: "Make-up Exam Enrty",
    makeup_letter_entry: "Make-up Letter Entry",
    make_up_additional_student_list: "List of Additional Students to Take Resit Exams",
    male: "Male",
    mass_course_closure: "Mass Course Closure",
    mass_absence_update: "Absence fixing",
    mass_absence_chose: 'Mass Polling Selection',
    major_major_dismissal_report: "Major Major Dismissal Report",
    mandatory: "Mandatory",
    max_capacity: "Max Capacity",
    max_duration: "Maximum Duration",
    max_class_average: "Maximum Class Average",
    max_score: "Maximum Score",
    material_requests: "Material Requests",
    maintenance_date: "Maintenance Date",
    medicine_group_code: "Medicine Group Code",
    medicine_groups_title: "Faculty of Medicine Exhange Student Groups",
    medicinegroup: "Medical Groups",
    medicines: "Medicine Taken Regularly if any",
    meeting_duration: "Duration of Meeting",
    meeting_number: "Meeting Number",
    meeting_place: "Meeting Place",
    meeting_type: "Meeting Type",
    meeting_add: "Meeting Add",
    meeting_date: "Meeting Date",
    meeting_planed_date: "Meeting Planed Date",
    meeting_doing_person: "Meeting Doing Person",
    meeting_content: "Meeting Content",
    meetings: "Meetings",
    meeting_note: "Meeting Note",
    meeting_status: "Meeting Status",
    member_type: "Member Type",
    menu: "Menu",
    menu_items: "Menu Items",
    mernis_edit: "Mernis Edit",
    message: "Message",
    message_en: "Message En",
    meb_ylsy: "Meb-Ylsy",
    medium_of_instruction: "Medium of Instruction",
    merge_section_deleted: "Merge Section Deleted",
    merge_equal_items: "Merge Equal Items",
    microsoft_user_id: "Microsoft User ID",
    microsoft_teams_group: "Microsoft Team Group",
    midterm_and_final_data_collection: "Midterm And Final Data Collection",
    midterm_exam: "Midterm Exam",
    midterm_week: "Midterm Week",
    week1: "1 Week",
    military: "Military Service",
    military_branch: "Military Service Branch Office",
    military_branch_number: "Military Service Branch Office Number",
    military_delay_date: "Military Service Postponement Date",
    military_information: "Military Service Information",
    military_office: "Military Service Recruiting Office",
    military_service_city: "City Code / Name",
    military_service_city_code: " City Code",
    medications_used: "Medications Used",
    military_status: "Military Service Status",
    military_status_document: "Military Service Status Document",
    min_pass_count: "Minimum Pass Count",
    min_point: "Minimum Score",
    min_ticket_count: "Min Ticket Count",
    min_rank: "Minimum Rank",
    min_score: "Minimum Score ",
    minor_application: "Minor Application",
    minor_application_leave_with_consent_report: "Minor Application Leave With Consent Report",
    minor_applications_yok_report: "Minor Applications YOK Report",
    minor_branch_dismissal_report_for_not_registering_for_courses: "Minor Branch Dismissal Report for Not Registering for Courses",
    major_graduate_minor_branch_dismissal_report: "Major Graduate Minor Branch Dismissal Report",
    minor_application_start: "Start your Minor Application",
    minor_application_quotas: "Minor Application Quotas",
    minor_applications: "Minor Applications",
    minor_programs: "",
    minor_certificate: "Minor Certificate",
    minor_certificate_ebys_send: "Yandal Sertifika EBYS Send",
    minute: "Minute",
    minutes: "Minutes",
    min_number_of_participants: "Minimum Number of Participants",
    min_relative_score: "Minimum Relative Score",
    min_final_score: "Minimum Final Score",
    min_semester_score: "Min Semester Score",
    ministry_of_health_registration_date: "Registration Date",
    ministry_of_health_registration_number: "Registration Number",
    health_registration_data_inquiry: "Health Registration Inquiry",
    migrate_to_undergraduate_student_data: "Migrate to Undergraduate Student Data",
    missing_document: "Missing Document",
    missing_documents: "Missing Documents",
    missing_documents_report: "Missing Documents Report",
    mobile_number: "Mobile Number",
    mobile_number_update: "Mobile Number Update",
    mobile_placeholder: "Enter Mobile Phone",
    mobile_verify_not: "Please Verify Mobile Number",
    mode_of_study: "Mode of Study",
    module: "Module",
    module_name: "Module Name",
    module_name_en: "Module Name (EN)",
    modality: "Modality",
    module_id: "Module (ID)",
    monday: "Monday",
    max_upload_file_info: `You can upload a maximum of {max_size} MB documents`,
    month: "Month",
    month3: "3 months",
    monthly_collection_report: "Monthly Collection Report",
    monthly_closing_report: "Monthly Closing Report",
    mother: "Mother",
    mother_gsm: "Mother's Gsm",
    mother_job: "Mother's Job",
    mother_name: "Mother Name",
    mothers_education: "Mother's Educational Status",
    mothers_gsm: "Mother's Gsm",
    my_library_reservations: "My Library Reservations",
    open_door: "Open Door",
    open_door_confirm_text: "Are you sure you want to open the door? Reservation cancellation cannot be made after this action.",
    open_door_fail: "Operation Failed",
    active_reservation: "Active Reservation",
    reservation_cancel: "Cancel Reservation",
    session_cancellation_confirm: "Are you sure you want to cancel this session?",

    mothers_job: "Mother's Job",
    move: "Move",
    move_here: "Move Here",
    move_payment: "Move Payment",
    move_payment_plan: "Move Payment Plan",
    move_up_course: "Move Course Up",
    multiple_choice: "Multiple Choice",
    multiselect_deselect: "Press enter to remove",
    multiselect_select: "Press enter to select",
    multiselect_selected: "Selected",
    must_have: "Credit to be Completed",
    message_bulk_btn: "B.Message",
    message_bulk_title: "Message Bulk Title",
    message_bulk_to: "To: Bulk delivery will be made according to the selected filters!",
    my_course_schedule: "My Course Schedule",
    my_jobs: "My Jobs",
    my_make_up_exams: "My MakeUp Exams",
    my_requests: "My Requests",
    my_courses: "My Courses",
    my_invoices: "My Invoices",
    minister_order_date: "Minister Order Date",
    minister_order_number: "Minister Order Number",
    my_profile: 'Graduate Profile',
    my_uploaded_documents: "My Uploaded Documents",
    my_observers: "My Observers",
    my_observer: "My Observer",
    message_send: "Message Send",
    message_new: "New Message",
    message_lock: "Message closed to reply",
    message_unlock: "Message open to reply",
    will_take_make_up_exams: "Will Take MakeUp Exams",

    // N
    new_student_dashboard: "Newly Registered Student Dashboard",
    new_students: "New Students",
    no_announcements: "There are no announcements.",
    no_info_found: "No Information Found",
    no_installment_message: "No Installment Message",
    no_options: "Option not found.",
    no_payment: "Please Make the Payment!",
    no_registration_data_found: "No registration data found to display.",
    no_result: "No Record Found",
    no_result_1: "Not Found",
    no_result_2: "Record not found",
    no_student_details_found: "No detailed student records found.",
    no_theoretical_course_selection_has_been_made:
        "Select the section",
    no_practical_course_selection_has_been_made:
        "No practical course selection has been made",
    non_dep_course_count: "Non Dep Course Count",
    non_dep_course_credit: "Non Dep Course Credit",
    non_dep_course_ects_credit: "Non Dep Course Ects Credit",
    Non_departmental_elective_ects_credit: "Departmental Elective ECTS Credit",
    none: "None",
    non_renewal_yu_student_report: "Withdrawal Report for Non-Renewal of Registration (YU)",
    non_renewal_student_report: "Withdrawal Report for Non-Renewal of Registration",
    non_renewal_all_student_report: "Non Renewal All Student Report (YU – 4 Semesters)",
    non_thesis_code: "Non-Thesis Program Code",
    number_of_people: "Number of People",
    not_verified: "Could not be verified",
    not_placed: "Not Placed",
    number_of_days: "Number Of Days",
    not_completed_undergraduate: "You were not considered because you did not complete your application.",
    not_sent: "Not Sent",
    not_working: "Not Working",
    number_of_report_days: "Number of report days",
    not_working_reason: "Not Working Reason",
    not_working_in_military: "In Military",
    not_working_no_info: "No Info",
    not_working_other: "Other",
    not_working_education: "Education",
    not_working_marriage: "Marriage",
    not_working_searching_job: "Searching Job",
    nationality_type: "Nationality Type",
    number_characters_entered: "Number of characters you entered",
    n_options_selected: "{n} options selected",
    name: "Name",
    name_en: "Name (EN)",
    name_placeholder: "Enter Your Name",
    name_surname: "Name Surname",
    national_credit: "National Credit",
    national_credit_of_uncompleted_slots:
        "National Credit of Uncompleted Slots",
    national_id: "National ID",
    national_id_passport_no: "National ID",
    national_id_placeholder: "Enter Your National ID",
    national_number: "TC ID Number",
    nationality: "Nationality",
    nationality_option: "Nationality Option",
    nationality_code: "Nationality Code",
    name_of_sender: "Name of Sender Organization",
    name_of_recipient: "Name of Recipient Organization",
    necessity: "Necessity",
    neighborhood: "Neighborhood",
    new: "New",
    new_draft: "New Draft",
    new_exam: "New Exam",
    new_option: "New Option",
    new_password: "New Password",
    new_password_repeat: "Repeat- New Password",
    new_payment_collection: "New Payment Collection",
    new_request: "New Request",
    new_and_reenrollment_collection_report: "New and Reenrollment Collection Report",
    new_question: "New Question",
    new_register: "New Student Registration",
    new_section: "New Section",
    new_status_radio: "Assign New Status ",
    new_window: "New Window",
    new_vinov_instruction: "New Vinov Instruction",
    next: "Next",
    no: "No",
    no_lessons_to_be_added: "No Lessons To Be Added",
    no_course: "No Course",
    no_grades_entered: "Grades Not Entered",
    number_of_semesters_greater_than_max_duration_report: "Report of Non-Senior Students Who Have Completed the Maximum Duration",
    last_four_semester_status_115_remaining_slot_report: "Student Report Who Cannot Reduce Slot Number to 1 After Being Assigned 4 Times Under Article 44",
    last_semester_status_remaining_slot_report: "Report of Students with at Most 5 Remaining Slots After Extra Exam 2 Term",
    not_allow_attendance_updates: "Not allow attendence Updates",
    not_have_payment_approval: "Payment Not Approved",
    not_include_calculation:
        "Number of Exams Not Included in GPA Calculations",
    not_required: "Not Required",
    not_required_documents: "The documents indicated with (*) must be uploaded.",
    not_taken: "Not Taken",
    not_uploaded: "Not uploaded",
    not_selected: "Not Selected",
    note: "Grade",
    note_for_document: "Note",
    note_you_want_to_add: "Note you want to add",
    notes: "Grades",
    notes_key: "Notes",
    notexcredit: "Grade x Credit",
    note_area: "Not Area",
    not_attended: "Absent",
    now_job: "Now Job",
    not_approved: "Not Approved",
    number: "Number",
    number_of_courses_taken: "Number of Courses Taken",
    number_of_done_exams: "Number of Exams Taken",
    number_of_exams: "Number of Exams",
    number_of_installments: "Number of Installments",
    number_of_students_and_collection_report: "Number of Students and Collection Report",
    number_of_leave_of_absence:
        "Number of Semesters Leave of Absence was taken",
    number_of_observers: "Number of Exam Observers / Invigilators",
    participant_count: "Participant Count",
    number_of_semesters_studied_out: "Number of Studied Out",
    number_of_promissory: "Number of Promissory Notes",
    number_of_records_updated: "Number of Records Updated",
    number_of_registered_courses: "Number of Registered Courses",
    number_of_remaining_semesters: "Number of Remaining Semesters",
    number_of_chairs: "Number Of Chairs",
    nurse: "Nurse",
    number_of_students_and_collection_by_classes_report: "Number of Students and Collection by Classes Report",
    number_of_semesters:
        "Number of Semesters Studied",
    number_of_semesters_studied: "Number of Semesters Studied",
    number_of_students_report: "Number of Students Report",
    number_of_class: "Number of Classes",
    number_of_students: "Number of Students",
    number_of_students_by_status_report: "Number of Students Report by Status",
    numerical_score: "Numerical Score",
    new_advisor_staff: "New Advisor Staff",
    number_of_electives_within_the_department: "Number Of Electives within the department",
    number_of_participants: "External Participation",
    number_of_pages: "Number of Pages",
    name_to_see: "Name To See",

    // O
    operation: "Operation",
    online_payment_read_and_approve: "I have read the <strong> online payment agreement</strong>, I understand, I accept.",
    objectives: "Objectives",
    oauth_confirmation_text: "{client} wants to login with your UMIS account.",
    observers: " Exam Observers",
    observer: "Observer",
    office: "Office",
    offset_amount: "Offset Amount",
    offset_balance_report: "Offset Balance Report",
    offset_report: "Offset Report",
    offset_date: "Offset Date",
    offset_total: "Offset Total",
    offsets_detail: "Offsets Detail",
    ok: "Ok",
    old_name: "Old Name",
    old_name_if_exists: "Old Name if Any",
    ombudsman: "Ombudsman",
    one_time_payment: "One Time Payment",
    ois_student_transfer: "OIS Student Transfer",
    ois_student_course_transfer: "OIS Student Course Transfer",
    online: "Online",
    online_credit_card: "Online Credit Card",
    online_reg_not_1: "Applied only to students placed with OSYM Exam score.",
    online_reg_not_2: "In case of a technical problem during online registration",
    online_reg_not_3: "contact via e-mail",
    online_reg_system: "Online Registration System",
    online_payment_text: `The dormitory fees are charged over a period of 9 months starting from October and ending in June, entailing the fall-spring semesters:

    1)	To those students who prefer to quit the dormitory before the starting date of the courses as announced in the Academic Calender of the University, 10 % of the dormitory fee is deducted and the rest is refunded.

    2)	To those students who started their first year after attaining a passing grade from the proficiency examination of the School of Foreign Languages of the University, a full refund is provided in case of their registering to the dormitory prior to the  examination.

    3)	In the event that students who have successfully passed the English Proficiency Exam given by the University’s School of Foreign Languages in the interim period wish to move out of the Dormitory, they  shall be charged the sum of the monthly accommodation service fees for the services delivered in the preceding months (including the current month) plus 30% of the monthly accommodation service fees for the rest of the contracted months; that is they shall be refunded 70% of the monthly accommodation service fees for the rest of the contracted months. The Service Delivery Contract is terminated.

    4)	For those who leave after the starting date of the courses; a refund is made available  after deducting the total fee of the months for which accommodation service is delivered, the full amount of the current month and 30% of the annual accommodation fee for the remaining months.

    5)	Students who will attend the 5th Module (Summer School) at the School of Foreign Languages will be charged an additional fee of 1 (one) month if they prefer to stay in the dormitory in July.

    6)	Fee refunds are deposited to the bank account that the student has declared within one month from the date of submitting his/her petition regarding the refund request. Approval of the Dormitory Management is sought by applying to the Dormitory Management with the approved Dormitory Dismissal Form and the petition regarding the refund request.`,
    open_parameter: "Properties of Parameters",
    option: "Option",
    orcid_id: "Orcid ID",
    order: "Order",
    OSYM_score_inquiry: "OSYM Score Inquiry",
    ordered: "Ordered",
    unordered: "Unordered",
    order_of_preference: "Order of Preference",
    osymDocCode: "????",
    osymExamCode: "????",
    osym_address_information: "OSYM Address Information",
    osym_scholarship_analysis_report: "OSYM Scholarship Analysis Report",
    osym_code: "OSYM Code",
    observer_attendance_statuses: "Observer Attendance Statuses",
    osym_information: "OSYM Information",
    osym_placement_document: "OSYM Placement Document",
    osym_result_document: "OSYM Result Document",
    osym_scholarship: "OSYM Scholarship",
    osym_score_information: "OSYM Score Information",
    osym_data: "OSYM Data",
    osymquota: "OSYM Quota",
    osym: "OSYM",
    osym_scholarship_rate: "ÖSYM Scholarship Rate",
    osym_100_scholarship: "100% ÖSYM Scholarship",
    osym_75_scholarship: "75% ÖSYM Scholarship",
    osym_50_scholarship: "50% ÖSYM Scholarship",
    osym_25_scholarship: "25% ÖSYM Scholarship",
    other: "Other",
    other_identies: "Other Identies",
    other_information: "Other Information",
    other_payments: "Other Payments",
    other_programs: "Other Programs",
    other_signers: 'Other Signers',
    other_university: "Other Universty",
    outbox: "Sent Items",
    out_of_field: "Out Of Field",
    other_documents: "Other Documents",
    other_payments_makeup_lesson: "Other Payments for Makeup Lessons",
    open: "Open",
    only_parent: "Only Main Installments",
    only_pdf_files_can_be_uploaded: "Only PDF Files Can Be Uploaded",
    only_png_files_can_be_uploaded: "Only PNG Files Can Be Uploaded",
    opera_music_singer: "Opera Singing",
    osym_exam_results: "OSYM Exam Results",
    osym_searching: "Searching in OSYM...",
    obp_point: "Secondary Education Success Score",
    occupational_profiles_of_graduates: "Occupational Profiles of Graduates",
    order_tr_en: "Order - Order",
    other_notes: "Other Notes",
    outputs: "Outputs",
    organization_message: "Hello, thank you for your application. Our organization team will contact you.",
    otomatic: 'Automatic',
    opera_and_choir_singing: "Opera and Choir Singing",
    options: "Options",
    outgoing_coordinators_full_name: "Outgoing Coordinator's Full Name (Home University)",
    outgoing_coordinators_email: "Outgoing Coordinator's Email Address (Home University)",
    outgoing_document: "Outgoing Document",

    // Q
    question: "Question",
    questioning: "Questioning",
    questions: "Questions",
    questioning_do: "Questioning Do",
    quota: "Quota",
    quota_management: "Quota Management",
    quota_type: "Quota Type",
    quota_type2: "Quota Type",
    qr_code_read: "Qr Code Read",
    qr_code_verify_stream: "Qr Code Verify Stream",
    student_number_short_tr: "Sort by Student Number",
    student_name_short_tr: "Sort by Student Name",
    student_number_short_en: "Sort by Student Number (English)",
    student_name_short_en: "Sort by Student Name (English)",
    student_application_date: "Student Application Date",
    student_approve_date: "Student Approve Date",
    // P
    phd_graduation_date: "Phd Graduation Date",
    professor_title_date: "Professor Title Date",
    professor_appointment_date: "Professor Appointment Date",
    pathname: "Pathname",
    payments: "Payments",
    patient_history: "Patient History",
    payment_or_refund: "Payment or Refund",
    parent_course_code: "Parent Course Code",
    past_application_date: "Past Application Date",
    past_application_date_desc: "This is not an application period for graduate programs. For current application dates and detailed information, please visit the Graduate Education Institute page.",
    past_application_date_desc_yl: "The application period for Master's programs is currently closed. Please visit the Graduate School page for up-to-date application dates and detailed information.",
    past_application_date_desc_d: "The application period for PhD programs is currently closed. Please visit the Graduate School page for up-to-date application dates and detailed information.",
    parent_course: "Parent Course",
    preference: "Preference",
    preference_date: "Preference Date",
    preference_delete: "Preference deleted",
    preference_add: "Preference add",
    price_edit: "Edit Prices",
    price_add: "Add Price",
    price_simulation: "Price Simulation",
    previous_course_code: "Previous Course Code",
    previous_course_name: "Previous Course Name",
    preparation_report_card_publication_date: "Preparation Report Card Publication Date",
    printed_materials: "Printed Materials ",
    private_classroom: "Private Classroom",
    prep_module_success_point: "Prep Module Success Point",
    previous: "Previous",
    placed: "Placed",
    place_student: "Place Student",
    place_student_are_you_sure: "Are you sure you want to pre-register the student?",
    proficiency_exams: "Proficiency Exams",
    page: "Page",
    page_not_found: "Page Not Found!",
    page_messages: "Page Messages",
    paid: "Paid",
    paid_statuses: "Paid Statuses",
    parameter: "Parameter",
    create_on_onexa: "Create On Onexa",
    parameter_id: "Parameter Id",
    parameter_items: "Parameter Items",
    parent_id: "Parent Id",
    parent_department: "Parent Department",
    parts: "Parts",
    participation: "Participation",
    passed_exams_report: "Passed Exams Report",
    passed_absence_report: "Passed Absence Report",
    passive: "Passive",
    passport_country: "Passport Country",
    passport: "Pasaport",
    passport_number: "Passport Number",
    password: "Password",
    payment_waiting: "Payment Waiting",
    payment_success: "Payment Success",
    payment_date_range: "Payment Date Range",
    password_contains_eight_characters_message:
        "Password Contains Eight Characters Message",
    password_contains_number_message: "Password Contains Number Message",
    password_contains_uppercase_message: "Password Contains Uppercase Message",
    password_contains_lowercase_message: "Password Contains Lowercase Message",
    password_contains_special_character_message:
        "Password Contains Special Character Message",
    password_send_success: "Your password has been sent successfully.",
    password_equals_message: "Password Equals Message",
    comment_question: "Comment Answer",
    pay: "Pay",
    pay_type: "Payment Type",
    pay_with_vakifbank_vinov: "Pay via Vakıfbank Vinov",
    payment_type1: "Payment Type",
    payment_start_date: "Payment Start Date",
    payment_end_date: "Payment End Date",
    payer: "Payer",
    payer_address: "Address of Payer",
    payer_national_id: "TC Identity Number of Payer",
    payer_phone: "Payer Phone",
    payment: "Payment",
    payment_amount: "Payment Amount",
    payment_approval: "Payment Approval",
    payment_approval_exceptions: "Payment Approval Exceptions",
    payment_approval_failed: "Payment Approval Failed",
    payment_approval_successful: "Payment Approval Successful",
    payment_approvals: "Payment Approvals",
    payment_date: "Date of Payment",
    payment_date_start: "Payment Date Start",
    payment_date_end: "Payment Date End",
    payment_info: "Payment Information",
    payment_info_message: "Once the payment is confirmed, you will be notified via email/SMS.",
    payment_info_update: "Update Payment Information",
    payment_method: "Payment Method",
    payment_plan: "Payment Plan",
    payment_plan_create_btn: "Create Payment Plan",
    payment_plan_title: "Payment Plans ",
    payment_plan_types: "Payment Plan Type",
    payment_plans: "Payment Plans",
    payment_plans_report: "Payment Plans Report",
    payment_scholarship_information: "Payment / Scholarship Information",
    payment_status: "Payment Status",
    payment_status_E: "There is",
    payment_status_H: "There is no",
    payment_total: "Amount to be Paid",
    payment_type: "Payment Type",
    payment_types: "Payment Types",
    payment_type_group: "Payment Type Group",
    payments_saved: "Payments Saved",
    payment_types_obj: {
        money_order: "Money order",
        credit_card: "Credit card",
    },
    please_select_a_course: "Please Select a Course",
    payments_report: "Payments Report",
    previous_exams_must_be_taken: "Previous exams must be taken",
    pending: "Pending",
    people: "People",
    period: "Period",
    period_code: "Period Code",
    period_id: "Period Name",
    period_status: "Period/Semester Status",
    period_x: "{period}. Semester",
    periods: "Periods",
    permission: "Permission",
    permission_id: "Process (id)",
    permission_information: "Permission Information",
    personal_email: "Personal E-Mail",
    personal_info: "Personal Details",
    personal_information: "Personal Information",
    person_data_import: "Person Data Import",
    personal_ticket_info: "For your event participation, an individual certificate will be awarded.",
    personnel: "Personnel",
    ph_programs_info: "(*) For Doctoral Programs.",
    photo: "Photo",
    pilotage_collection_report: "Pilotage Collection Report",
    pilotage_invoices: "Pilotage Invoices",
    pilotage_prices: "Pilotage Prices",
    pilotage_payment_report: "Pilotage Payment Report",
    pilotage_payment_summary_report: "Pilotage Payment Summary Report",
    pilotage_invoices_report: "Pilotage Invoices Report",
    pin_code: "Pin Code",
    pin: "Pin",
    place_added: "Place Added",
    placement_exam: "Placement ",
    program_outcome_definition_name: "Program Outcome",
    program_basic_fields: "Program Basic Fields",
    program_level_outcomes: "Program Level Outcomes",
    program_levels: "Program Levels",
    pos_return_days: "Post Return Days",
    program_basic_field_outcomes: "Program Basic Field Outcomes",
    program_transition_information: "Program Transition Information",
    proficiency_status_title: "Proficiency Status Title",
    prep_student_document: "Preparatory Students Document Upload",
    prep_transcript: "Prep Transcript",
    placemnet_exam_report: "Placement Exam Report",
    placement_exam_classroom_delete_confirm_text:
        "Placement Exam Classroom Delete Confirm Text",
    placement_exam_classroom_store_confirm_text:
        "Placement Exam Classroom Store Confirm Text",
    placement_exam_classrooms_add_student: "Add / Edit Student",
    placement_exam_classrooms_define: "Placement Exam Classrooms Define",
    placement_exam_classrooms_info: "Placement Exam Classrooms Info",
    placement_exam_classrooms_ranking: "Placement Exam Classrooms Ranking",
    placement_exam_classrooms_ranking_success:
        "Placement Exam Classrooms Ranking Success",
    placement_exam_classrooms_students: "Placement Exam Classroom Students",
    placement_exam_classrooms_title: "Placement Exam Classrooms",
    placement_exam_part_classroom_delete_confirm_text:
        "Placement Exam Part Classroom Delete Confirm Text",
    placement_exam_part_classroom_store_confirm_text:
        "Placement Exam Part Classroom Store Confirm Text",
    placement_exam_part_classrooms_define:
        " Classroom Assignment for Placement Exam Part",
    placement_exam_part_classrooms_ranking:
        "Classroom Rankings for Placement Exam Part",
    placement_exam_part_classrooms_ranking_success:
        "Placement Exam Part Classrooms Ranking Success",
    placement_exam_part_classrooms_title:
        "Placement Exam Part Classrooms Title",
    placement_exam_part_classrooms_update:
        "Placement Exam Part Classrooms Update",
    placement_exam_part_classrooms_update_info:
        "Placement Exam Part Classrooms Update Info",
    placement_exam_score_upload_info: "Placement Exam Score Upload Info",
    placement_exam_score_upload_title: "Placement Exam Score Upload Title",
    placement_exam_name: "Placement Exam Name",
    placement_exams: "Placement  Exams",
    placement_rank: "Placement Ranking",
    placement_student: "Placement Student",
    preparationPeriodNo: "Preparation Period No",
    program_accepted: "You have been accepted into the program",
    program_spare: "Spare",
    program_other_placed: "You settled on your other preference",
    program_applied_bau: "Program Applied of Bahçeşehir University",
    program_vertical: "Program Transfer",
    placement_student_result: "Yerleştirme Sonuçları",
    placement_score: "Placement Score",
    placement_success_order: "Placement with respect to Success Rankings",
    plate: "Plate",
    please_try_again: "Please Try Again",
    please_select_a_ticket_type: "Select  PASS Type ",
    point: "Grade Weight",
    point_type: "Type of Score",
    points: "Points",
    pool: "Pool",
    pool_name: "Pool Name",
    pool_name_en: "Pool Name (EN)",
    pool_type: "Pool Type",
    pool_edit: "Pool Edit",
    postal_code: "Postal Code",
    practical: "Practical",
    position: "Position",
    practical_credit: "Practical Credit",
    precondition: "Prerequisite",
    preference_information: "Preference Information",
    preference_procedures: "Preference Procedures",
    preference_restore_success: "Preference Reset",
    preference_please_add: "Add your preferences",
    preferences: "Preference",
    preferences_delete: "Delete Preference",
    preferences_edit: "Preferences Edit",
    preference_restore: "Preference Restore",
    preferences_order_change: "Change order of preference",
    preferred_program: "Preferred Program",
    prefers: "Prefers",
    preliminary_information_form: "Preliminary Information Form",
    prepare_entry: "Prepare Data",
    prep_academic_year: "Academic Year of the English Prep Program",
    prep_attendance: "Prep Attendance Entry",
    prep_attendance_confirmation_modal: "Prep Attendance Confirmation Modal",
    prep_attendance_publish_modal: "Prep Attendance Publish Modal",
    prep_classes_define_form: "Prep Classes Define Form",
    prep_classes_delete_confirm_text: "Prep Classes Delete Confirm Text",
    prep_classes_store_confirm_text: "Prep Classes Store Confirm Text",
    prep_classes_title: "Prep Classes",
    prep_classes_update_confirm_text:
        "You are about to update the Prep Class registration, do you confirm the action??",
    prep_classes_update_form: "Prep Classes Update Form",
    prep_classes_update_info: "Prep Classes Information",
    prep_exam_confirmation_modal: "Prep Exam Confirmation Modal",
    prep_exam_definitions: "Prep Exam Definitions",
    prep_exam_publish_modal: "Prep Exam Publish Modal",
    prep_grade_certificate: "Prep Grade Certificate",
    prep_grade_entry: "Prep Program Grade Entry",
    promontial_application_form: "Promontion Application Form",
    prep_holiday_day: "Prep Holiday Day",
    have_a_message: "Have a Message?",
    intra_department_elective_credit: "Intra Department Elective Credit",
    non_departmental_elective_credit: "Non Department Elective Credit",
    prep_levels: "Prep Levels",
    prep_modules: "Prep Program Modules",
    prep_reports: "Prep Program Reports",
    prep_schedule: "Prep Program Schedule",
    prep_schedule_draft_delete_confirm_text:
        "Prep_Schedule_Draft_Delete_Confirm_Text",
    prep_schedule_draft_store_confirm_text:
        "Prep_Schedule_Draft_Store_Confirm_Text",
    prep_schedule_draft_title: "Prep Program Schedule Drafts",
    prep_schedule_import_data_excel_format:
        "Classroom Name, Level, Class, Day, Start Time, End Time, Start Time, End Time, Start Time, End Time, Start Time, End Time, Start Time, End Time, Instructor ID, Instructor Overlap, Class Overlap",
    prep_school: "Prep School",
    prep_school_approval: "Prep School Approval?",
    prep_status: "Prep Program Status",
    payment_confirmation_document: "Payment Confirmation Document",
    prep_students_import_excel_format: "Student Number, Level, Class(Section)",
    prep_students_slot_situations: "Prep Students Slot Situations",
    prep_attendance_status: "Prep Attendance Status",
    prep_exam_status: "Prep Exam Status",
    preparation_note_entry: "Preparation Note Entry",
    preparation_slot_status: "Preparation Slot Status",
    preparatory_information: "Preparatory Information",
    preparatory_information_send: "Preparatory Information Sent",
    preparatory_bulk_grade_entry: "Preparatory Bulk Grade Entry",
    preparatory_class_advancement_blocking: "Preparatory Class Advancement Blocking",
    preparatory_notes: "Prep Report Card",
    prerequisites: "Prerequisites",
    preparation_for_bulk_import_operations: "Preparation for Bulk Import Operations",
    preparation_level_grade_entry: "Preparation Level Grade Entry",
    present: "Present",
    preview: "Preview",
    personnel_ID_number: "Personnel ID Number",
    preview_btn_info:
        "Click the save button below to complete the application!",
    preview_save_btn_info:
        "You can save your application without uploading your documents. After saving you will get a follow link. You can upload your documents by logging in from the link below.",
    president: "President",
    price: "Fee",
    protocol_number: "Protocol Number",
    price_type: "Price Type",
    priceless: "Priceless",
    prices: "Fees",
    print: "Print",
    placement_exam_scores_excel: "Student Number,Point,Program Code",
    print_mail_order_form: "Print Mail Order Form",
    print_promissory_note: "Print Promissory Note",
    print_receipt: "Print Receipt",
    print_roster: "Attendance List",
    print_weekly_roste: "Weekly Attendance List",
    proccess_success: "Proccess Successful",
    proccess_will_be_started:
        "The proccess will be started. Do you confirm the Procees? ",
    process: "Process",
    process_select: "Process Select",
    process_type: "Process Type",
    processes: "Processes",
    processing: "Processing",
    processing_information: "Information Processing",
    processing_model: "Information Processing Model",
    product: "Product",
    product_code: "Product Code",
    products: "Products",
    profession_job: "Profession / Job",
    proficiency_certificate_type: "Proficiency Certificate Type",
    proficiency_document: "Proficiency Certificate",
    proficiency_exam: "Proficiency ",
    proficiency_exam_entry_status: "Proficiency Exam Entry Status",
    proficiency_requests: "English Proficiency Requests",
    proficiency_status: "Proficieny Status",
    proforma_invoice: "Proforma Invoice",
    proforma_invoices: "Proforma Invoices",
    program: "Program",
    program_code: "Program Code",
    program_code_name: "Program Code / Name",
    program_codes: "Program Codes",
    program_coordinator: "Program Coordinator",
    program_days: "Program Days",
    program_decrease: "Click to remove from selected programs.",
    program_delete_info:
        "You are about to delete the selected Program. Do you want to continue processing?",
    program_info: "Program Information",
    program_information: "Select Program",
    program_language: "Language of Instruction for the Program",
    program_level: "Program Level",
    program_level_1: "Education Level",
    program_level_d: "Doctorate",
    program_level_l: "Undergraduate Degree Program",
    program_level_ol: "Associate Degree Program",
    program_level_yl: "Master's Degree Program",
    program_name: "Program Name",
    program_name_en: "Program Name (EN)",
    program_select: "Program Selection",
    program_select_min: "Please choose at least one program!",
    program_selected: "The program has already been selected.",
    programs: "Programs",
    programs_applied: "Programs Applied",
    programs_selected: "Programs Selected",
    programs_to_choose: "Programs to Choose",
    programs_you_are_applying: "Programs You Are Applying",
    program_groups: "Program Groups",
    program_of_registration: "Program of registration",
    project_advisory: "Project Advisory",
    promissory_no: "Promissory No",
    promissory_note: "Promissory Note",
    promissory_payment: "Promissory Payment",
    provision: "Provision",
    promotion_code: "Promotion Code",
    promotion_code_message: "Promotional code applied successfully!",
    promotion_code_error_message: "Promotional code is incorrect!!",
    promotional_process: "Promotional Process",
    public_scholarship: "Public Scholarship",
    publish: "Publish",
    publish_at: "Publish At",
    published: "Published",
    punishment: "Punishment",
    punishment_number: "Punishment Number",
    punishment_end_date: "Punishment End Date",
    punishment_start_date: "Punishment Start Date",
    ph_documents_info:
        'You can select your documents by clicking on the "Choose File" label. To complete the upload process, you must click the "+" icon.',
    purchase_ticket: "Purchase Ticket",
    purchase_successful: "Purchase Successful",
    purchased_tickets: "Purchased Tickets",
    purchase_a: "Purchase a",
    product_prices_import_format:
        "Faculty Code, Program Code, Registration Academic Year, Student Group, Price, Currency, Due Date, Number of Installments, Start Date, End Date",
    proficiency_point: "Proficiency point",
    program_groups_lte: "Graduate Program Groups",
    please_upload_image: "Please upload your photograph below. (Please upload a photo of yourself facing forward)",
    please_upload_identity: "Please upload a photo of the front side of your passport or Turkish ID card in the field below.",
    province_name: "Province Name",
    positional_status: "Positional Status",
    position_detail: "Position Detail",
    password_sent: "Password Sent.",
    prep_number_of_semesters: "Number of Semesters Studied in Prep",
    purpose: "Purpose",
    purchased_ticket_not_found: "Purchased ticket not found",
    pilotage_payment: "Pilotage Payment",
    popular_music_singing: "Popular Music Singing",
    portfolio: "Portfolio",
    portfolio_share_link: "Portfolio Share Link",
    privacy_notice: "Privacy Notice",
    privacy_policy: "Privacy Policy",

    // R
    raise_rates: "Raise Rates",
    raise_rate: "Raise Rate",
    resend_code: "Resend Code",
    record_selected: "records selected",
    record_type: {
        manual: "Manual",
        online: "Online",
    },
    readonly: "Readonly",
    requirements: "Requirements",
    application_submitted_success: "Your Application Has Been Successfully Submitted!",
    application_submitted_info: "To view your application, go to umis.bau.edu.tr/visitorstudent/application/login. Enter the PIN code sent to your email address during registration along with your T.R. Identity No / Passport No to access your application.",
    registration_date_just: "Registration Date Just",
    random: "Random",
    rank: "Rank",
    ranking: "Ranking",
    read_and_accept: "I have read and I approve",
    reason: "Reason",
    reason_for_leaving: "Reason for Leaving",
    reason_for_return: "Refund Reason",
    reason_for_rejection: "Reason for Rejection",
    return_your_account: "Return Your Account",
    reason_to_increase_max_duration: "REASON TO INCREASE MAX TIME",
    receipt_number: "Receipt Number",
    receipt_number_format: "Receipt Number Format",
    receipt_number_not_created: "Failed to generate receipt number",
    receipt_search: "Receipt Search",
    receiver_delay: "Is there a delay?",
    rector: "Rector",
    rector_title: "Rector Title",
    rector_title_en: "Rector Title (EN)",
    rectors_order: "Rector's Order",
    receipts: "Receipts",
    rector_order_date: "Rector Order Date",
    rector_order_number: "Rector Order Number",
    responsible_person_update: "Responsible Person Update",
    refund: "Refund",
    refunds: "Refunds",
    refund_amount: "Refund Amount",
    refund_date: "Refund Date",
    refund_form: "Refund Form",
    refund_reason: "Reason for Refund",
    refund_request: "Refund Request",
    refund_request_list: "Refund Request List",
    refund_type: "Types of Refund",
    registration: "Registration",
    referred_hospital: "Referred Hospital",
    registration_and_Collection_report: "Registration and Collection Report",
    registration_academic_year: "Registration Academic Year",
    registration_data: "Registration Data",
    registration_date: "Registration Date",
    register_online: "Register Online",
    registration_dates: "Registration Dates",
    registration_date_between: "Registration Date Range",
    registration_delete_text:
        "You are about to delete the record. Do you approve the transaction?",
    registration_document_types: "Registration Document Types",
    registration_guide: "Registration Guide",
    registration_hour: "Registration Hour",
    registration_information: "Registration Information",
    registration_number: "Registration Number",
    registration_season: "Registration Semester",
    registration_semester: "Registration Period",
    registration_statement: "Registration Statement",
    registration_status: "Registration Status",
    registration_statuses: "Registration Statuses",
    registered_students: "Registered",
    registered_student_count: "{count} students registered",
    registration_type: "Registration Type",
    receiver: "Receiver",
    registration_type_code: "Registration Type Code",
    registration_type_1: "Registration Type",
    registration_type_2: "Registration Type",
    registration_type_registration: "Registration",
    registration_type_student: "Student",
    registration_types: "Registration Types",
    registration_numbers_by_faculty_osym_report: "Registration Numbers by Faculty (OSYM)",
    register_start_date: "Register Start Date",
    register_end_date: "Register End Date",
    registration_year: "Year of Registration",
    registrations: "Registrations",
    registrations_page_bulk_student_transfer: "Registrations Page Bulk Student Transfer",
    registrations_bulk_delete: "Registrations Bulk Delete",
    rector_behalf: "Rector Behalf",
    rector_title_behalf: "Rector Title Behalf",
    rector_title_en_behalf: "Rector Title Behalf (EN)",
    rector_behalf_start_date: "Rector Behalf Start Date",
    rector_behalf_end_date: "Rector Behalf End Date",
    receive_reservation: "Receive Reservation",
    rejected: "Rejected",
    reject: "Reject",
    relative_grades: "Relative Grades",
    remaining_amount: "Remaining Amount",
    remaining_credit: "Remaining Credits",
    remaining_payment_amount: "Remaining Payment Amount",
    remaining_quota: "Remaining Capacity",
    remaining_students: "Remaining",
    responsible_remaining_day_count: "Responsible Remaining Day Count",
    remaining_students_radio: "Remaining Students",
    remove_exception_payment_approval: "Remove Exception Payment Approval",
    remove: "Remove",
    remove_approve: "Remove Approve",
    remind_password: "Remind Password",
    repeat: "Repeat",
    repeat_count: "Repeat Count",
    repeat_student_count: "Number of Repeat Students",
    repeat_type: "Repeat Type",
    repeated_registration: "Repeated Registration",
    repetition_status: "Repetition Status",
    repetition_status_1: "Repetition Status",
    report: "Report",
    report_type: "Report Type",
    reporter_analysis_report: "Reporter Analysis Report",
    reporter_assignment_letter: "Reporter Assignment Letter",
    responsible_person: "Responsible Person",
    responsible_person_email: "Responsible Person Email",
    request_data_count: "Request Data Count",
    request_date: "Request Date",
    request_date_range: "Request Date Range",
    request_information: "Request Information",
    request_number: "Request Number",
    request_reason: "Request Reason",
    request_type: "Request Type",
    requests_info: "Requests",
    requests_of_leave_with_consent: "Requests Of Leave With Consent",
    request_result: "Request Result",
    required: "Required",
    required_course_count: "Required Course Count",
    required_course_credit: "Required Course Credit",
    required_course_ects_credit: "Required Course Ects Credit",
    requirement_list: "Requirement List",
    reservation_add: "Reservation Add",
    reservation_system: "Reservation System",
    reservation_type: "Reservation Type",
    reservations: "reservations",
    reset: "Reset",
    residence_address: "Residence Address",
    residence_city: "Residence City",
    residence_permit: "Residence Permit",
    residence_permit_end_date: "Residence Permit End Date",
    residence_permit_no: "Residence Permit No",
    residence_permit_start_date: "Residence Permit Start Date",
    residence_permit_validity_dates: "Residence Permit Validity Dates",
    residence_permit_validity_end_date: "Validity End Date",
    residence_permit_validity_start_date: "Validity Start Date",
    responsible_email: "Responsible Email",
    responsible_name: "Responsible Name",
    responsible_surname: "Responsible Surname",
    responsiblePerson: "Responsible Person",
    responsible: "Responsible",
    meeting_description: "Meeting Description",
    meeting_report: "Meeting Report",
    registration_academic_years: "Registration Academic Years",
    result: "Result",
    results: "Results",
    rector_order_excel_import: "Rector Order Excel Import",
    role: "Role",
    role_permissions: "Role Permission",
    roles: "Roles",
    role_excel: "Role Excel",
    role_filter: "Role Filtering",
    room: "Room",
    reference_letter: "Reference Letter",
    route_permissions: "Route Permissions",
    registration_numbers_by_faculty_report: "Registration Numbers by Faculty Report",
    registration_academic_year_semester: "Registration Academic Year Semester",

    // S
    select_image_upload: "Select the image you want to upload",
    select_level: "Select Level",
    same_number: "Same Number",
    second_language: "Second Language",
    second_prep_module_success_point: "Second Prep Module Success Point",
    second_prep_proficiency_success_point: "Second Prep Proficiency Success Point",
    merged_sections: "Merged Sections",
    search_section: "Section Search",
    student_transcript: "Transcript",
    student_affairs_grade_import: "Student Affairs Grade Import",
    student_affairs_academic_year: "Student Affairs Academic Year",
    student_affairs_period: "Student Affairs Period",
    sample_template_excel: "Sample Template Excel",
    student_affairs_exam_type: "Student Affairs Exam Type",
    student_english_language_proficiency_document: "Language Proficiency Certificate",
    surveyReportJob: "Survey Report Job",
    s_grade_conversion: "S Grade Conversion",
    saturday: "Saturday",
    save: "Save",
    save_and_continue: "Save and Continue",
    save_application: "Save Application",
    save_preferences: "Save Preferences",
    send_preferences: "Send Preferences",
    set_as_active_step: "Set as Active Step",
    saved: "Saved",
    scala_id: "Scale ID",
    scala_name: "Scale Name",
    show_on_login: "Show on Login",
    scholarship_detail: "Scholarship Detail",
    scholarship_rate: "Scholarship",
    scholarship_status: "Scholarship Status",
    scholarship_type: "Scholarship Type",
    scholarships: "Scholarships",
    scholarship_status_form: "Scholarship Status Form",
    scholarshiptypes: "Type of Scholarship",
    scholor_ship_rate_ration: "Without Scholarships",
    school: "School",
    school_name: "Name of School",
    signed_document_preview: "Signed Document Preview",
    signature_captured_successfully: "Signature Captured Successfully",
    school_certificate: "School Certificate",
    scholarship_report: "Scholarship Report",
    scholarship_collection_report: "Scholarship Collection Report",
    scholarship_analysis_report: "Scholarship Analysis Report",
    school_council_date: "School Council Date",
    school_council_number: "School Council Number",
    scientific_preparation: "Scientific Preparation",
    scientific_preparation_courses: "Bilimsel Hazırlık Dersleri",
    scopus_id: "Scopus ID",
    score: "Score",
    score_information: "Score Information",
    score_type: "Type of Score",
    score_with_the_selected_program: "Score With The Selected Program",
    search: "Search",
    search_course: "Search Course",
    seat: "Seat No",
    seating_types: "Seating Types",
    section: "Section",
    section_1: "Section",
    section_message: "please choose a section",
    section_detail: "Section Detail",
    section_not_found: "Section Not Found",
    section_count: "Number of Sections",
    section_id: "Section Id",
    section_information: "Section Information",
    section_operations: "SECTION Operations",
    section_type: "Section Type",
    sections: "Sections",
    section_import_excel:
        "Course Code, Section, Instructor Id, Quota , Type, Section Language",
    section_detail_import_excel:
        "Course Code, Section, Detail Type, Detail Code, Detail, Invert",
    section_detail_excel_export: "Detail",
    section_update_success:
        "{name} {surname} student's section has been updated to {section}.",
    section_update_unsuccess:
        "{name} {surname} student's section could not be updated to {section}.",
    select: "Select",
    select_btn: "Select",
    selected_course: "Selected Course",
    selected_courses: "Selected Courses",
    select_date: "Select Date",
    select_file: "Select File",
    select_is_cash_or_installment: "Peşin mi taksitli mi olduğunu seçiniz",
    select_it: "Select",
    select_program: "Select Program",
    selected_field_is_invalid: "Selected %{numberof} field invalid",
    select_report_type: "Select Report Type",
    select_all: "Select All",
    semester: "Semester",
    semester_1: "Academic Year/Semester",
    semester_count: "Number of Semesters",
    semester_registration_information: "Semester / Registration Information",
    semester_settings: "Semester Settings",
    semester_status: "Semester Status",
    semester_text: "Semester",
    semester_text_en: "Semester (EN)",
    semester_title: "Semester",
    semester_x: "Semester {semester}",
    semesterdate: "Semester Dates",
    semesters: "Semesters",
    semester_info: "Semester Information",
    sent: "Sent",
    send: "Send",
    semester_add: "Add Semester",
    semester_status_analysis: "Semester Status Analysis",
    send_again: "Send Again",
    send_again_btn: "Send Again (button)",
    send_again_not: "Click on the Send Again button and try again",
    send_approve: "Send Approve",
    send_password: "Send Password",
    send_request: "Send Request",
    send_application: "Send Application",
    student_detail_absence_report: "Student Detail Absence Report",
    send_sms: "Send SMS",
    send_verification_code: "Send Verification Code",
    send_yoksis_transcript: "Send Yoksis Transkript",
    student_clubs_finance_report: "Student Clubs Finance Report",
    services: "Services",
    session: "Session",
    session_timeout_warning: "Your session is about to end",
    special_student_application_form: "Special Student Application Form",
    guest_student_application_system: "Guest Student Application System",
    guest_student_application_form: "Guest Student Application Form",
    visitor_student_application_form: "Visitor Student Application Form",
    guest_student: "Guest Student",
    guest_student_rules_agreement: "I have read and accepted the information above.",
    guest_student_kvkk_agreement: "I agree to the processing of my personal information shared with Bahçeşehir University as part of my application, for the purpose of evaluating my application.",
    guest_student_save_application: "SAVE APPLICATION",
    please_upload_required_documents: "Please Upload the Required Documents.",
    please_upload_required_documents_error: "Please upload the required (*) documents.",
    document_upload_format_info: "You can only upload documents in PDF, JPG or PNG format, with a maximum size of 5MB.",
    files_selected: "files selected",
    already_uploaded: "Uploaded",
    information_text: "Information Text",
    guest_student_prep_faculty_warning: "If you are applying to study in the preparatory program, you must select School of Foreign Languages -> Department of Modern Languages -> Preparatory in the Faculty section.",
    english_proficiency_exam_question: "Will you take the BAU English Proficiency Exam?",
    english_proficiency_exam_yes_desc: "If you select Yes, your starting level in the English Preparatory Program will be determined based on the results of the English Proficiency Exam to be held on the date announced in the academic calendar.",
    english_proficiency_exam_no_desc: "If you select No, you will be required to start your education in the English Preparatory Program from the lowest level.",
    prep_exam_doctoral_warning: "Doctoral students cannot register for the English Preparatory Program and cannot take the English Proficiency Exam administered by our University.",
    graduate_course_limit_warning: "You can take a maximum of four courses.",
    bachelors_diploma: "Bachelor's Diploma",
    bachelors_transcript: "Bachelor's Transcript",
    masters_diploma: "Master's Diploma",
    masters_transcript: "Master's Transcript",
    ales_certificate: "ALES Certificate",
    program_level_lise: "High School",
    program_level_prep: "English Preparatory",
    guest_student_general_rule: "The guest student application is valid for only one semester. To be a guest student in subsequent semesters, a new application is mandatory.",
    guest_student_ug_title: "BAU Associate and Undergraduate Education and Examination Regulations<br>Admission of Guest and Special Students",
    guest_student_ug_body: "ARTICLE 8 - (1) Guest students are those who are not enrolled in any university education program but are permitted to attend certain courses. The admission and courses to be taken by guest students are determined with the recommendation of the relevant academic department/program and the approval of the relevant dean/director. Guest students cannot benefit from student rights other than attending classes. However, a document showing the courses they are registered for and the grades they received, if any, is given to them. For guest students who then fully enroll at the University according to the provisions of Article 6, procedures such as course exemption for lateral transfer between Bahçeşehir University programs are applied for the courses they have taken and succeeded in, as deemed appropriate.<br><br>(2) Students studying at the associate or undergraduate level in another higher education institution in Turkey or abroad may apply to take courses at the University as special students. Applications are evaluated by the relevant department/program head and decided by the board of directors of the academic unit applied to. Special students are given a document indicating the courses they took and their success grades.<br><br>(3) Special and guest students may be admitted to the English Preparatory Program with the approval of the Directorate of the School of Foreign Languages.<br><br>(4) (Addition: RG-25/1/2023-32084) Among students studying in undergraduate programs, those with a general point average of 3.00 and above may take a maximum of two graduate courses as (NI) courses during their education, provided they are approved in terms of content and level by the Graduate Education Institute. If the student enrolls in a graduate program related to these courses they successfully completed at the University, the relevant courses are evaluated to be adapted together with their grades.<br><br>(5) The tuition fees of these students are determined by the Board of Trustees.",
    guest_student_grad_title: "Admission of guest students to BAU Graduate programs",
    guest_student_grad_body: "ARTICLE 37 - (1) Students enrolled in a master's, doctorate or proficiency in art program may be admitted as special students to graduate courses with the approval of the Institute department/art major coordinatorship and the admission conditions determined by the Institute Board of Directors.<br><br>(2) Special student status is not an education directly aimed at obtaining a degree in the relevant program, and its duration cannot exceed two semesters. Those taking courses under special student status are not registered in any program and cannot benefit from student rights. The admission of special students and the courses they will take at the Institute are determined by the proposal of the Institute department/art major head/coordinator and the Decision of the Institute Board of Directors. A document about the courses taken and their successes is given to special students.<br><br>(3) In the course exemption procedures for graduate courses taken and passed as a special student at the University by students who fulfill the necessary conditions and are admitted to a graduate program, they can transfer a maximum of four courses to the program they are registered in with the proposal of the Institute department/art major coordinatorship and the decision of the Institute Board of Directors. The total credit of the exempted courses cannot exceed 50% of the total credit of the courses given in the relevant graduate education.",

    special_student_general_rule: "The special student application is valid for only one semester. To be a special student in subsequent semesters, a new application is mandatory.",
    special_student_ug_title: "BAU Associate and Undergraduate Education and Examination Regulations<br>Admission of Guest and Special Students",
    special_student_ug_body: "ARTICLE 8 - (1) Guest students are those who are not enrolled in any university education program but are permitted to attend certain courses. The admission and courses to be taken by guest students are determined with the recommendation of the relevant academic department/program and the approval of the relevant dean/director. Guest students cannot benefit from student rights other than attending classes. However, a document showing the courses they are registered for and the grades they received, if any, is given to them. For guest students who then fully enroll at the University according to the provisions of Article 6, procedures such as course exemption for lateral transfer between Bahçeşehir University programs are applied for the courses they have taken and succeeded in, as deemed appropriate.<br><br>(2) Students studying at the associate or undergraduate level in another higher education institution in Turkey or abroad may apply to take courses at the University as special students. Applications are evaluated by the relevant department/program head and decided by the board of directors of the academic unit applied to. Special students are given a document indicating the courses they took and their success grades.<br><br>(3) Special and guest students may be admitted to the English Preparatory Program with the approval of the Directorate of the School of Foreign Languages.<br><br>(4) (Addition: RG-25/1/2023-32084) Among students studying in undergraduate programs, those with a general point average of 3.00 and above may take a maximum of two graduate courses as (NI) courses during their education, provided they are approved in terms of content and level by the Graduate Education Institute. If the student enrolls in a graduate program related to these courses they successfully completed at the University, the relevant courses are evaluated to be adapted together with their grades.<br><br>(5) The tuition fees of these students are determined by the Board of Trustees.",
    special_student_grad_title: "Admission of special students to BAU Graduate programs",
    special_student_grad_body: "ARTICLE 37 - (1) Students enrolled in a master's, doctorate or proficiency in art program may be admitted as special students to graduate courses with the approval of the Institute department/art major coordinatorship and the admission conditions determined by the Institute Board of Directors.<br><br>(2) Special student status is not an education directly aimed at obtaining a degree in the relevant program, and its duration cannot exceed two semesters. Those taking courses under special student status are not registered in any program and cannot benefit from student rights. The admission of special students and the courses they will take at the Institute are determined by the proposal of the Institute department/art major head/coordinator and the Decision of the Institute Board of Directors. A document about the courses taken and their successes is given to special students.<br><br>(3) In the course exemption procedures for graduate courses taken and passed as a special student at the University by students who fulfill the necessary conditions and are admitted to a graduate program, they can transfer a maximum of four courses to the program they are registered in with the proposal of the Institute department/art major coordinatorship and the decision of the Institute Board of Directors. The total credit of the exempted courses cannot exceed 50% of the total credit of the courses given in the relevant graduate education.",
    special_student_rules_agreement: "I have read and accepted the information above.",
    special_student_kvkk_agreement: "I agree to the processing of my personal information shared with Bahçeşehir University as part of my application, for the purpose of evaluating my application.",
    document_approval: "Document Approval",
    special_student: "Special Student",
    uploaded_documents: "Uploaded Documents",
    academic_unit_review: "Academic Unit Approval",
    institute_review: "Institute Approval",
    document_file: "Document",
    document_name: "Document Name",
    document_description: "Document Description",
    rejection_reason: "Rejection Reason",
    graduate_course_limit: "You can take a maximum of four courses.",
    please_select_course_from_list: "Please select a course from the list.",
    course_already_in_list: "This course has already been added to your list.",
    click_or_drag: "Click or Drag",
    application_info_title: "1- Information",
    program_selection_title: "2- Program Selection",
    graduate_level_text: "Graduate / Doctorate",
    undergraduate_level_text: "Associate / Undergraduate",
    course_registration_title: "3- Course Registration",
    no_course_added: "No courses added yet.",
    please_select_at_least_one_course: "Please select at least one course.",
    available_sections: "Available Sections",
    please_select_program_first: "Please select a program first.",
    no_section_found: "No sections found for this program.",
    selected: "Selected",
    documents_title: "4- Documents",
    no_document_uploaded: "No documents uploaded yet.",
    application_save_success: "Your application has been successfully saved!",
    session_timeout_warning_text: "Your session is about to expire. Do you want to continue ?",
    session_timeout_continue: "Continue",
    session_timeout_logout: "End Session",
    settlement_scholarship: "Settlement Scholarship",
    set_passive_without_any_student_course_sections: "Set Passive Without Any Student Course Sections",
    short_name: "Short Name",
    short_name_en: "Short Name (EN)",
    show: "View",
    show_details: "Show Details",
    show_or_update: "Show/Update",
    show_application: "Show/View Application",
    search_by_osym: "Fetch from ÖSYM",
    search_by_yoksis: "Search By Yoksis",
    search_student_placeholder: "Search Name Surname, Program or Scholarship...",
    show_empty_classrooms: "Show Empty Classrooms",
    signature: "Signature",
    signature_name: "Signature Name",
    signature_type: "Signature Type",
    section_status: "Section Status",
    sign_up: "Sign Up",
    signer: "Signer",
    semester_name: "Semester Name",
    signers: 'Signers',
    signer_name_surname: "Signatory",
    signer_national_id: "Signer ID Number",
    signer_title: "Signer Title",
    signer_title_en: "Signer Title(EN)",
    single: "Single",
    science_field: "Science Field",
    slot: "Slot",
    slot_type: "Slot Type",
    slot_type_code: "Slot Type Code",
    slot_types: "Slot Types",
    slots: "Slots",
    slot_status: "Slot Status",
    special_student_applications: "Special Student Applications",
    send_to_secretaries: "Send to Secretaries",
    something_went_wrong: "An Error Has Occurred ",
    sorry_we_could_not_find_the_page_you_were_looking_for:
        "Sorry we could not find the page you were looking for",
    sort: "Sort",
    sort_by_graduation_grade_point_average:
        "Sort by Graduation Grade Point Average",
    sorting_by_semester_grade_point_average:
        "Sorting by Semester Grade Point Average",
    sort_by_semester_grade_point_average:
        "Sort by Semester Grade Point Average",
    sound_systems: "Sound Systems",
    speaker_lecturer: "Speaker Lecturer",
    speaking_exam: "Speaking Exam",
    spring: "Spring",
    spring_credit: "Spring Credit",
    staff: "Staff",
    staff_information: "Staff Information",
    start: "Start",
    start_date: "Start Date",
    start_kilometer: "Start Kilometer",
    start_process: "Start Process",
    start_proccess: "Start",
    start_time: "Start Time",
    statement1_error:
        "Verify the authenticity of the information entered on the record monitor/website",
    statement2_error:
        "Confirm the ClarificationText Regarding Processing of Personal Data",
    statement3_error:
        "Confirm the Explicit Consent Text Regarding Processing of Personal Data",
    statement4_error:
        "Confirm the online payment agreement!",
    statement5_error: "You cannot pay with the installment option by wire transfer.",
    statement_1:
        "I declare that the informatiıon I entered the record monitor is true and correct.",
    statement_2:
        "I confirm that I have read and understood the <a href=#>ClarificationText</a>' regarding Precessing of Personal Data.",
    statement_3: "Explicit Consent Text Regarding Processing of Personal Data",
    statement_4:
        "Explicit Consent Text Regarding Processing of Personal Data(Pilotage)",
    status: "Status",
    stay_of_execution_decision: "Stay Of Execution Decision",
    step_name: "Step Name",
    status_approval_awaited: "Approval is Awaited",
    status_approved: "Status Approved",
    status_required_message: "Filling in the required fields marked as 'Select' is mandatory.",
    status_accepted: "Status Approved",
    status_declined: "Status Declined",
    status_denied: "Status Denied",
    status_update: "Status Update",
    status_waiting_payment: "Waiting Payment",
    status_uploaded: "Status Uploaded",
    status_waiting: "Status Waiting",
    status_waiting_publish: "Status Waiting Publish",
    street: "Street",
    street_and_no: "Street No",
    special_talent_exam: "Special Talent Exam",
    student: "Student",
    student_slots_title: "Student Slots",
    student_explanation: "Student Explanation",
    student_exam_data: "Stu.Ex.Data",
    student_unihall_info: "To be registered for the period {0}",
    student_unihall_info1: "Residing outside of Istanbul",
    student_unihall_info2: "Being a BAU preparatory class student",
    student_bea_bau: "Be a BAU Student",
    student_document_create1: "Student Document Create",
    student_affairs: "Student Affairs",
    student_approval_sent_date: "Student Approval Sent Date",
    student_certificate: "Student Certificate",
    student_collection_report: "Student Collection Report",
    student_count: "Number of Students",
    student_course: 'Student Course',
    student_course_delete: 'Student Course Delete',
    student_courses_title: "Course Analysis Report",
    student_document_create: "Create Student Document",
    student_email: "Student E-Mail",
    student_gno_simulation: "Student CGPA Simulation",
    student_gno_report: "Student GNO Report",
    student_graduation_requirement_report:
        "Student Graduation Requirement Report",
    student_group: "Student Group",
    student_grade_entry_failed:
        "Grade entry  failed for student number {number} and name {name}",
    student_information: "Student Information",
    student_based_full_schedule_report: "Course Schedule Change Report",
    student_program_transfer: "Program Transfer Excel Import",
    student_information_system: "Student Information System",
    student_list: "Student List",
    student_list_report: "Student List Report",
    student_list_with_photo: "Student List (with Photo)",
    student_mobile_number: "Student Mobile Number",
    student_name: "Student Name",
    student_number: "Student No",
    student_number_format: "Student Number Format",
    student_number_long: "Student Number",
    student_numbers: "Student Numbers",
    student_notes_report: "Student Notes Report",
    student_program_class_success_title: "Class Success Rank",
    student_program_graduation_success_title: "Graduation Success Rank",
    student_report: "Student Report",
    student_reports: "Student Reports",
    student_section_change: "Student Section Change",
    student_sections: "Student Sections",
    student_educational_status: "Student Educational Status",
    student_semester_count: "Student Semester Count",
    student_semester_report: "Semester Status Report",
    student_semester_status_update: "Student Semester Status Update",
    student_situation_certificate: "Student Situation Certificate",
    student_slots: "Student Slots",
    student_status: "Student Status",
    student_status_btn: "Student Status ",
    student_status_changes: "Student Status Changes",
    student_surname: "Student Surname",
    student_numbers_by_nationality_and_faculty: "Student Numbers by Nationality and Faculty",
    section_for_repeats: "Section for Repeats",
    scholarships_import: "Scholarships Import",
    student_card: "Student Card",
    student_ticket: "Student Ticket",
    study_cycle: "Study Cycle",
    spring_and_fall: "Spring && Fall",
    search_kps_by_student_numbers: "Search KPS by Student Numbers",
    search_kps_by_staff_national_id: "KPS Inquiry with Personnel TR Identity Number",
    staff_tc: "Personnel T.R. Identity No",



    students: "Students",
    student_program_id: "Student Program ID",
    studied: "Studied",
    student_preference_reset_info: "Are you sure you are about to reset the student's preference?",
    student_preferences: "Student preferences",
    student_club_applications: "Club Presidential Elections",
    students_should_take_course: "Students Should Take Course",
    students_should_take_elective: "Student Slot Students Should Take Elective",
    students_should_take_courses: "Students Should Take Courses",
    subject: "Subject",
    subject_en: "Subject EN",
    subtitle: "Subtitle",
    sub_course_code: "Sub Course Code",
    sub_course_section: "Sub Course Section",
    success: "Success",
    success_data_count: "Success Data Count",
    success_rate: "Success Rates",
    success_ranking: "Success Ranking",
    success_rate1: "Success Rate",
    success_status: "Success Status",
    success_order: "Success Order",
    success_status_report: "Success Status Report",
    success_status_document: "Success Status Document",
    successfully_added: "Successfully Added",
    successfully_changed: "Successfully Changed",
    successfully_deleted: "Successfully Deleted",
    sum_of_credits: "Sum of Credits",
    sum_of_ects_credits: "Sum of ECTS Credits",
    story: "Story",
    summary: "Summary",
    student_programs_graduation_requirement: "Student Programs Graduation Requirement",
    summary_of_project: "Summary of Project",
    summary_of_thesis: "Summary of Thesis",
    summary_statement_content: "Summary Statement Content",
    summer: "Summer",
    summer_credit: "Summer Credit",
    summer_school_report: "Summer School Report",
    sunday: "Sunday",
    survey_result_download: "Survey Result Downland",
    surgery_illness_history: "History of any Surgery or Chronic Diseases",
    surgery_or_discomfort: "Surgery or Chronic Diseases if any ",
    surname: "Surname",
    surname_placeholder: "Enter your Surname",
    survey: "Survey",
    survey_questions: "Survey Questions",
    survey_result: "Survey Result",
    survey_result_show: "View Survey Result",
    surveys: "Surveys",
    switch_user: "Switch User",
    synchronous: "Synchronous",
    system_name: "System Name",
    show_in_diploma_supplement: "Show In Diploma Supplement",
    student_clubs: "Student Clubs",
    student_club_member_search: "Club Member Search",
    speacial_student_error: "Speacial Students Can Not Register Courses",
    schedule_overlap_message:
        "The course you want to take overlaps with #course.",
    system_maintance:
        "If you are viewing this page, please follow the DNS information update steps in the instructions below.",
    system_maintance_2: "Thank you for your understanding.",
    student_absence_report: "Student Absence Report",
    student_overlap_report: "Student Overlap Report",
    select_theoretical_section: "Select theoretical section",
    survey_comment_question_select: "Select comment question.",
    select_practical_section: "Select practical section",
    survey_question_about_course: "Questions About the Course",
    survey_staff_avg: "Instructor Average",
    survey_faculty_avg: "Faculty Average",
    survey_university_avg: "University Average",
    sending_sms: "Sending SMS",
    sending_sms_student_search: "Sending SMS Student Search",
    sending_sms_with_mobile_phone_information: "Sending SMS with Mobile Phone Information",
    sending_sms_to_staff: "Sending SMS To Staff",
    send_sms_excel: "National Id,Student Number,Phone Number",
    survey_results: "Survey Results",
    survey_results_loading: "Survey Results Calculating",
    survey_instructor_results: "Instructor Survey Results",
    special_scholarship_rate: "Special Scholarship Rate",
    special_scholarship_code: "Special Scholarship Code",
    special_scholarship: "Special Scholarship",
    speaker: "Speaker",
    sponsor: "Sponsor",
    still_working: "Still Working",
    school_found_job_opportunity: "School Found Job Opportunity",
    sporty: "Sporty",
    social_cultural: "Social-Cultural",
    t_score_multiplier: "Core Multiplier",
    t_score_effect: "Score Effect",
    table_11_yok_report: "Table 11 YOK Report",
    table_11b_yok_report: "Table 11b YOK Report",
    table_11b_transfer_students_report: "Table 11B: Transfer Students List",
    table_11c_transfer_quota_and_registration_report: "Table 11C: Transfer Quota and Registration Information",
    table_13_double_major_students_report: "Table 13: Double Major Students List",
    table_14_minor_students_report: "Table 14: Minor Students List",
    table_15b_scholarship_students_distribution_report: "Table 15B: Distribution of Scholarship Students",
    table_15c_graduate_programs_scholarship_data_report: "Table 15C: Graduate Degree Programs Scholarship Data",
    two_factor_authentication: "Two Factor",
    take_the_lesson: "Select Course",
    date_took_the_course: "Date Took the Course",
    taking_during_active_semester: "Taking During Active Semester",
    that_course_had_been_taken: "That course had been taken for another slot before",
    task_type: "Task Type",
    tc_no: "Turkish Identification Number",
    tc_or_passport: "TC Identity / Passport No",
    teaching_staff: "Instructor",
    teaching_staff_no: "Teaching Staff No",
    transfer_count: "Total Number of Adapted Courses",
    transfer_toles_applications: "Transfer Toles Applications",
    transfer_committee_coordinator: "Transfer Committee Coordinator",
    temporary_graduation: "Temporary Graduation Certificate",
    telephone: "Phone",
    terminal: "Terminal",
    top_menu: "Top Menu",
    technological_materials: "Technological Materials",
    the_class_finished_in_the_program_came: "Thesis Title",
    the_person_who_person: "Added By",
    the_values_you_entered_have_already_been_added:
        "The Values You Entered Have Already Been Added",
    theoretical: "Theoretical",
    theoretical_credit: "Theoretical Credit",
    theoric: "Theoretical",
    thesis_project_advisor_report: "Report of the Instructor Providing Thesis-Project Consultancy",
    thesis_and_project_status: "Thesis and Project Status",
    total_ects_range_completed: "Total ECTS Range Completed",
    total_credit_range_completed: "Total Credit Range Completed",
    total_number_of_working_days: "Total Number of Working Days",
    total_payment: "Total Payment",
    tyc_right: "Tyc Right",
    two_copies: "Second Copy",
    two_copies_wet_signature: "Second Copy with Wet Signature",
    two_copies_wet_signature_PDF: "Wet signature Second Copy",
    theoric_section: "Teoric Section",
    there_are_no_records: "No record found",
    there_is: "There is",
    there_is_a_protocol: "There is a Protocol",
    there_is_any_course_in_active_semester:
        "Course not found in the Active Semester",
    there_is_no_authorization: "There is no authorization",
    thesis_advisor: "Thesis Advisor",
    thesis_advisory: "Thesis Advisory",
    thesis_co_advisor: "Thesis Co-Advisor",
    thesis_code: "Thesis Program Code",
    thesis_and_project: "Thesis and Project",
    thesis_and_topic_determination: "Thesis and Topic Determination",
    turkmer_admin_page_title: "Turkmer Programs Application List",
    thesis_and_project_advisor_approve_title:
        " View Coordinator/ Advisor Applications",
    thesis_and_project_application: "Thesis & Project Application",
    thesis_and_project_coordinator_approve_title:
        "Thesis & Project Coordinator Approve Title",
    thesis_and_project_info: "Thesis & Project Information",
    thesis_and_projects_admin_title: "Thesis and Projects Admin",
    thesis_and_projects_admin_update: "Thesis and Projects Admin Update",
    thesis_students: "Thesis Students",
    transitions: "Translations",
    tr_name: "TR Name",
    translate: "Translate",
    en_name: "EN Name",
    thesis_title: "Thesis Title",
    threshold_value: "Threshold Value",
    this_field_is_required: "This field is required.",
    thursday: "Thursday",
    title1: "Title",
    title2: "Title",
    title: "Title",
    title_en: "Title Of Project (English)",
    title_ge: "Title Of Project (Georgian)",
    summary_ge: "Summary Of Project  (Georgian)",
    summary_en: "Summary Of Project  (English)",
    titles: "Titles",
    title_of_project: "Title of Project",
    title_of_thesis: "Title of Thesis",
    title_title: "Title",
    timeout_amount: "Timeout Amount",
    toles_application_form: "Toles Application Form",
    toles_applications: "Toles Applications",
    toles_application_form_bau_question: "Are you a current student or a graduate of Bahçeşehir University?",
    to_score: "To Score",
    to_email: "To E-Mail",
    toefl_password: "Toefl Password",
    toefl_username: "Toefl Username",
    total_advisory: "Total Advisory",
    total_amount: "Total Amount",
    total_course_count: "Total Course Count",
    total_credits: "Total Course Credits Adapted",
    total: "Total",
    total_credits_attempted: "Total Credits Attempted",
    total_credits_earned: "Total Credits Earned",
    total_debt: "Total Debt",
    total_counted_credit: "Total Number of Adapted Credits",
    total_discount: "Total Discount",
    total_discount_amount: "Total Discount Amount",
    total_discount_rate: "Total Discount Rate",
    total_ects_credits: "Total AKTS Credits",
    total_ects_credits_attempted: "Total ECTS Credits Attempted",
    total_ects_credits_earned: "Total ECTS Credits Earned",
    total_installment: "Total Installment",
    today: 'Today',
    today_registered_students: "Registered Today",
    total_paid: "Total Paid",
    treatment: "Treatment",
    total_points: "Total Points",
    total_refund: "Total Refund",
    topic: "Topic",
    total_slots: "Total Slots",
    total_student_count: "Total Number of Students",
    total_capacity: "Total Capacity",
    take_the_survey: "Take the survey",
    transaction_date: "Transaction Date",
    transaction_start_date: "Transaction Start Date",
    transaction_end_date: "Transaction End Date",
    transaction_reference: "Transaction Reference",
    transcript: "Transcript",
    transcript_certificate: "Transcript Certificate",
    transcript_publication_date: "Transcript Publication Date",
    transport_audio_video_systems: "Transport Audio Video Systems",
    true: "True",
    tuesday: "Tuesday",
    tuition: "Tuition Fee",
    turkey: "Turkey",
    turkish: "Turkish",
    turkmer_page_title: "Turkish Preparatory School Application Form",
    turkmer_page_show_title: "Turkmer Programs Application Show",
    turn_back: "Go Back",
    type: "Type",
    type_of_acceptance: "Type of Acceptance",
    type_of_agreement: "Type of Agreement",
    type_detail: "Type Detail",
    type_of_delivery: "Type of Delivery",
    type_of_program_score: "Type of Program Score",
    tax_explanation: "VAT is included in the above mentioned tuition fees. We would like to remind you that it is possible for the public authority to change tax rates during the service period. In this context, if the VAT rate is increased or decreased, it is possible that this change will be reflected in the tuition fee. VAT rate on tuition fees is 10%.",
    tax_number: 'Tax Number',
    tyt_year: "TYT Year",
    tyt_score: "TYT Score",
    tyt_info: "Your TYT exam score will be automatically reflected after the TYT exam results are announced.",
    transfer_graduate_application_scholarships: "Transfer Graduate Application Scholarships",
    turkish_music: "Turkish Music",
    turkish_music_voice_education: "Turkish Music Voice Education",
    turkmer: "Turkmer",
    turkish_national_id_number: "Turkish National ID Number",
    ticket_event_promotion_codes: "Ticket Event Promotion Codes",
    ticket_amount: "Ticket Amount",
    ticket_message: "The International Future AI Summit'25 is taking place on April 16-17 at BAU Beşiktaş South Campus! Under the theme of 'Metamorph', this unique event offers you the chance to meet global leaders in the field of artificial intelligence, attend inspiring sessions, and experience interactive activities. BOOK YOUR PASS.",
    ticket_message1: "Your certificate has not been reserved yet; you can modify your selection.",
    ticket_message2: "Installment payments may be subject to different interest rates depending on the bank.",
    ticket_message3: "By using this site, you are deemed to have read and accepted the Terms of Use.",
    ticket_success_message: "Thank you for completing your purchase! Your ticket has been successfully created, and we look forward to seeing you at the Future AI Summit'25. You can download the tickets issued in your name below.",
    ticket_type: "Ticket Type",
    ticket_count: "Ticket Count",
    ticket_information: "Ticket Information",
    ticket_event_type: "Ticket Event Type",
    ticket_event: "Ticket Event",
    ticket_no_enter: "Ticket No Enter",
    ticket_check: "Ticket Check",
    ticket_no: "Ticket No",
    ticket_tracker: "Ticket Sales Tracking Screen",
    ticket_count_individual_message: "Tickets can be purchased for 1 to 4 people.",
    ticket_count_group_message: "An event certificate can be purchased for between 5 and 10 people",
    ticket: "Ticket",
    turkish_folk_music: "Turkish Folk Music",
    to_date: "To Date",
    troy_cash_campaign: "Troy Cash Campaign",
    take_on_application: "Take on Application",

    // I
    in_life: "In Life",
    infirmary: "Infirmary",
    issue_date: "Issue Date",
    interview_preference: "Interview Preference",
    industry: "Industry",
    internship_information: "Internship Information",
    interview_exam_participation: "Interview Exam Participation",
    interview_exam_participation_score: "Interview Exam Participation Score",
    internship_remaining_count: "Internship Remaining Count",
    interest_rate: "Interest Rate",
    index_of_document: "Index of Document",
    index_by_bau: "Index by Bau",
    is_certificate_sent: "Is Certificate Sent",
    instructor_course_load_report: "Instructor Course Load Report",
    instructor_attendance: "Instructor Attendance",
    in_field: "In Field",
    internship_manager_name: "Internship Manager Name",
    internship_manager_surname: "Internship Manager Surname",
    internship_manager_email: "Internship Manager E-mail",
    internship_type: "Internship Type",
    internship_application: "Internship Application",
    include_cancelled: "Include Cancelled",
    is_one_row: "Is One Row",
    is_take_application_date: "Is Take Application Date",
    is_approve_date: "Is Approve Date",
    is_online_required: "Is Online Required",
    import_extra_payments: "Import Extra Payments",
    identity_card_placeholder: "Identity Card Placeholder",
    identity_front: "Passport Front Page/Front Side",
    incoming_document: "Incoming Document",
    invoice_report: "Invoice Report",
    is_same_program: "Is Same Program?",
    // U
    unread: "Unred",
    read: "Read",
    unihall_country_code: {
        TR: "Turkey",
        YU: "Abroad"
    },
    user: "User",
    ulmer: "Ulmer",

    unihall_approvet_payment: "Your payment has been confirmed",
    undergraduate_associate_degree: "Undergraduate Associate Degree",
    update_release_status: "Unpublish attendance",
    update_summer_school_paid_status: "Update Summer School Payment Statuses",
    update_student_course_name: "Update Student Course Name",
    update_student_bulk_course_name: "Bulk Course Name Update for Students",
    unihall_applications_title: "Dormitory Room Applications",
    unihall_payment_note: "Note: Student's Name and Surname / Room Type /T.C. should be entered in the 'Explanation' field when making the transfer. Identity Number must be written",
    unihall_payment_note1: "Dear students, Fall-Spring semester dormitory payments are made over 9 months (October-June). Incomplete payments will not be accepted as final registration and will be returned to you. If your money transfer payment is not sent to the system within 1 hour (60 minutes), your application will be cancelled.",
    unihall_quota: "Dorm Rooms",
    unihall_quotas_title: "Dormitory Room Capacities",
    unihall_quotas_price_title: "Dormitory Room Price",
    unihall_quota_select: "Room Selection",
    unihall_quota_type: "Room type",
    unihall_cash_price: "Advance Fee",
    unihall_installment_price: "Installment Fee",
    unihall_remaining_quota: "Remaining Quota",
    unihall_make_order_info_text: "Your application process has been sent to APPROVAL, if you pay the fee within 1 hour, your application & payment will be approved, your application will be canceled if the time expires.",
    unihall_approved_message: "Student Dormitory Accommodation Fee Payments are made annually for the Fall – Spring Semesters covering a 9-month period (September – June). Payments that are not made in full will not be accepted as final registration and will be refunded to you.<br><br>1) For Turkish citizens, a photocopy of the identity card ( for foreign nationals, a photocopy of their passports),<br>2) Document for the registration status of the student to the university ( for foreign nationals, certificate of educational permit),<br>3) Four passport photos,<br>4) Medical Health Report verifying that the student’s state of health is suited for living together with other people (obtained from a Health Care Center, State or Private Hospital),<br>5) Documentation of the police records and archives,<br>6) For students of foreign nationalities, documentation of residential permit to be obtained from security department.",
    unihall_quota_full: "The dorm quotas are full. Thank you for your interest. Students who want to apply for the reserve list can send their student name, surname, school number, contact information and residence address to <a href='mailto:info@unihall.org'>info@unihall.org</a>.",
    unihall_room_info_update: "Update Room Information",
    unauthorized_operation: "Unauthorized Operation",
    undergraduate_transfer: "Undergraduate Transfer",
    undergraduate_transfer_maintenance: "Undergraduate Transfer Maintenance",
    undergraduate_transfer_maintenance_description: "Manage the options used in undergraduate transfer applications as active or passive.",
    undergraduate_types: "Application Types",
    undergraduate_transfer_program_levels: "Program Levels",
    undergraduate_transfer_types: "Transfer Types",
    point_types_in: "Internal Point Types",
    point_types_domestic: "Domestic Point Types",
    point_types_abroad: "International Point Types",
    point_types: "Point Types",
    refresh: "Refresh",
    no_record_found: "No records found",
    an_error_occurred: "An error occurred during the operation.",
    calculate_placed_students: "Calculate Placed Students",
    download_placed_students: "Download Placed Student List",
    publish_placement_results: "Publish Placement Results",
    transfer_placed_students_to_registrations: "Transfer Placed Students to Registrations",
    archive_old_records: "Archive Old Records",
    publish_placement_results_irreversible_warning: "The placement results will be published. This action cannot be undone. Are you sure you want to continue?",
    are_you_sure: "Are you sure?",
    operation_successful: "The operation was completed successfully.",
    placed_students: "Placed Students",
    constant_settings: "Constant Settings",
    undergraduate_transfer_constant_settings_description: "Manage undergraduate transfer application dates, semester and placement settings.",
    undergraduate_transfer_start_date: "Application Start Date",
    undergraduate_transfer_end_date: "Application End Date",
    placement_result_status: "Publish Results to Students",
    undergraduate_transfer_applications: "Undergraduate Transfer Applications",
    undergraduate_transfer_quotas: "Undergraduate Transfer Quotas",
    undergraduate_transfer_yok_report: "Undergraduate Transfer YOK Report",
    undergraduate_vertical: "LATERAL/VERTICAL Transition",
    undergraduate_vertical_transfer: "LATERAL/VERTICAL Transition",
    undergraduate_check_date_message: "You cannot apply because the applications are not active yet.",
    unidentified_payments: "Unidentified Payments",
    unpublish_scores: "Unpublish Scores",
    university_of_registration: "University of registration",
    unit: "Unit",
    university_graduate_inquiry: "University Graduate Inquiry",
    unit_id: "Unit İd",
    units: "Units",
    update_period_status: "Update Period Status",
    students_active_university_information: "student's active university information",

    universities: "Universities",
    university: "University",
    university_not_list: "My University Is Not In The List",
    updating_credits_and_ects: "Updating Credits And ECTS",
    unit_long_name: "Unit Long Name",
    unit_type: "Unit Type",
    unit_teach_lang: "Unit Teach Language",
    unit_teach_type: "Unit Teach Type",
    university_status: "Domestic / Abroad",
    university_courses: "University Courses",
    university_grade_scale_matching: "University Grading Scale Matching",
    university_grades: "University Grades",
    university_id: "University ID",
    ulmer_payment_note: `Please remember to include your <strong>Full Name</strong> and <strong>Turkish Republic Identity Number</strong> in the description section.`,
    university_informations: "University Information",
    university_rank: "University Ranking",
    university_type: "University Type",
    university_add: "University Add",
    university_name: "University Name",
    university_where_the_course_was_taken:
        "University where the course was taken",
    unpublished: "Unpublished",
    update: "Update",
    urgent_inquiries_help_text: `You may send urgent inquiries via <a href='https://bau.edu.tr/help'>help.bau.edu.tr</a>`,
    special_student_application_system: "Special Student Application System",
    update_classes_title: " Class Update Process",
    update_document: "Update Document",
    update_draft: "Update Draft",
    update_info_btn: "Update Contact Information",
    update_register: "Student Registration Update.",
    updated_at: "Updated At",
    system_update_dates: "System Update Dates",
    backend_update_date: "Backend",
    frontend_update_date: "Frontend",
    no_update_information: "No update information available",
    updated: "Updated",
    upload: "Upload",
    upload_file: "Uploading File",
    upload_your_documents: "Download your documents",
    update_staff_expiration_date: "Bulk Update Staff Expiration Date",
    uploaded_files: "Uploaded Files",
    unsuccessful: "Unsuccessful",
    url: "URL",
    used_drugs: "Medicine you take regularly if any",
    user_quide: "User Guide",
    user_quide_check: "Please confirm that you have read, understood, and agreed.",
    user_type: "User Type",
    username: "Username",
    username_info_update: "Username Info Update",
    user_filter: "User Filter",
    uploaded_student_documents: "Uploaded Student Documents",
    user_model_filters: "User Model Filters",
    user_filter_value: "User Filter Value",
    user_model: "User Model",
    user_filter_type: "User Filter Type",
    user_id: "User ID",
    user_transfer: "User Transfer",
    update_acceptance_letters: "Update Acceptance Letters",
    university_id_and_name: "University ID - University Name",
    unit_name: "Unit Name",
    // V
    validity_dates: "Validity Period",
    visit_date: "Visit Date",
    valid_cart: "Please enter a valid card number.",
    variable_language: `${process.env.VUE_APP_PROJECT_EXCEPTION === "BATUM" ? "GE" : "TR"}`,
    validity_season_end: "Validity Season End",
    validity_season_start: "Validity Season Start",
    validity_date_start: "Validity Start Date",
    validity_date_end: "Validity End Date",
    valid_date: "Valid Date",
    value: "Value",
    verbal_score: "Verbal_Score",
    verification: "Verification",
    voluntary: "Voluntary",
    verification_code: "Verification Code",
    verification_method: "Verification Method",
    verification_method_not_found: "Verification Method Not Found",
    verification_personal_info: "Verification with Personal Info",
    verification_sms_code: "Verification with SMS Code",
    verified: "Verified",
    verify: "Verify",
    verify_code_again_not: "Verification Code Sent Again",
    verify_code_error: "Verify Code Error",
    vertical_transfer: "Vertical Transfer",
    vertical_transition_and_vertical_transition_supplementary: "Vertical Transition and Vertical Transition Supplementary",
    view: "View",
    village: "Village",
    virman: "Virman",
    vinov_installments: "Vinov Installments",
    vinov_id: "Vinov ID",
    virtual_pos: "Virtual Pos",
    vinov_instructions: "Vinov Instructions",
    vice_president: "Vice President",
    video: "Videos",
    exam_request_message: "The exam request collection is not active.",
    view_and_edit: "View And Edit",
    virman_date: "Virman Date",
    visa_support_letter: "Visa Support Letter",


    // W
    waiting: "Waiting",
    waiting_approve: "Waiting Approve",
    waiting_program: "Waiting Program",
    waiting_payment: "Waiting payment",
    waiting_preference: "Waiting Preference",
    waiting_prep_school: "Waiting Prep School",
    waiting_academic_unit_office: "Waiting Academic Unit Office",
    waiters_approved: "Approved Applications",
    waiters_for_approve: "Applications Pending Approval",
    waiters_rejected: "Applications Rejected",
    want_leave_of_absence:
        "Will There Be a Request to Apply for Leave of Absence?",
    want_leave_of_absence_missing: "Want_Leave_Of_Absence_Missing",
    want_transfer_out: "Has Transfer Out Request",
    want_optional_prep: "Want_Optional_Prep",
    want_optional_prep_missing: "Want_Optional_Prep_Missing",
    warning: "Warning",
    wednesday: "Wednesday",
    weight: "Weight",
    week: "Week",
    weekend_in: "Weekend In",
    weekend_out: "Weekend Out",
    welcome: "Welcome",
    welcome_letter: "Welcome Letter",
    welcome_to: "Welcome to",
    whole_price: "Whole Price",
    wire: "Wire / (EFT) Electronic Funds Transfer",
    wire_info: "Remittance Information is as Below",
    with_installment: "With Installment",
    with_mobile_number: "With Mobile Number",
    with_personal_information: "With Personal Information",
    with_thesis: "With Thesis",
    wdc_course_code: "WDC Course Code",
    wdc_course_name: "WDC Course Name",
    wdc_credit: "WDC Course Credit",
    wdc_slot_type: "WDC Slot Type",
    with_without_thesis: "With Without Thesis",
    withdraw_requests: "Withdraw Requests",
    without_thesis: "Without Thesis",
    without_scholarship: "Without Scholarship",
    witness_complainant_statement: "Witness Complainant Statement",
    work_status: "Work Status",
    working: "Working",
    work_history: "Work History",
    work_start_date: "Work Start Date",
    work_leave_date: "Work Leave Date",
    working_type: "Working Type",
    working_tract: "Working Tract",
    working_end_date: "Ending Date of Employment",
    working_start_date: "Starting Date of Employment",
    working_status: "Attendance Status",
    write_verify_code: "Enter Verification Code sent to your mobile phone",
    write_verify_code_mail: "Enter Verification Code sent to your email",
    written_and_oral_defense_report: "Written And Oral Defense Report",
    written_exam: "Written Exam",
    want_to_purchase: "Want to Purchase a Ticket",
    write_reason_for_rejection: "Write the Reason for Rejection",
    was_elected: "Was Elected",
    wdc_course_list: "Wdc Course List",
    // Y
    you_will_directed: "You will be directed shortly",
    year: "Year",
    year_code: "Year Code",
    year_count: "Year Count",
    year_of_birth: "Year of Birth",
    yearly: "Yearly",
    yes: "Yes",
    yl_payment_plan: "YL Payment Plan",
    yoksis: "Yoksis",
    yoksis_code: "Yoksis Code",
    yoksis_import_title: "Yoksis Import",
    yoksis_information_cancel: "Yoksis Information Cancel",
    yoksis_search_student: "Yoksis Search Student",
    yok_notifications: "Yoksis Notifications",
    yoksis_information_import: "Yoksis Information Import",
    yoksis_multiaction: "Yoksis Multiaction",
    yoksis_undergraduate_transfer_list: "Yoksis Undergraduate Transfer List",
    yoksis_searching: "Yoksis Searching",
    yoksis_information_update: "Yoksis Information Update",
    yoksis_number_of_semesters: "Yoksis Number of Semesters",
    yoksis_unit_id: "Yoksis Unit Id",
    yoksis_operations: "Yoksis Operations",
    your_session_has_expired: "Your session has expired.",
    yoksis_student_id: "Yoksis Student ID",
    yoksis_student_questioning: "Yoksis Student Questioning",
    yoksis_units: "Yoksis Units",
    yoksis_preparatory: "Yoksis Preparatory",
    yoksis_status: "Yoksis Status",
    yoksis_meb_graduate_questioning: "Yoksis Graduate Questioning",
    yoksis_permissions: "Yoksis Permissions",
    yoksis_lists: "Yoksis Lists",
    yoksis_universities: "Yoksis Universities",
    yoksis_parameter: "Yoksis Parameter",
    yoksis_report_type: "Yoksis Report Type",
    yok_full_scholarship_control_report: "Yoksis Full Scholarship Control Report",
    yok_registration_status_report: "YOK Registration Status Report",
    you_can_combine_up_to_five_lessons: "You can combine up to five lessons",
    you_are_not_authorized_for_this_operation:
        "You are not authorized for this operation.",
    you_can_try_again_after_1_minute: "You can try again after 1 minute.",
    you_dont_have_a_payment_plan: "You do not have a Payment Plan",
    you_have_to_upload_the_files_first: "You have to upload the files first!",
    you_have_tried_too_many: "You have tried too many.",
    you_must_fill_in_the_fields_indicated_in_red:
        "You are required to fill in the fields indicated in red",
    you_must_do_change: "You must make changes",
    your_chosen_courses: "Courses Selected",
    your_payment_transaction_has_been_successfully_completed:
        "Your payment transaction has been successfully completed",
    your_preferences: "Your Preferences",
    your_preferences_waiting: "Your preferences are awaited",
    your_programs: "Your Programs",
    your_selected_permission: "Your Selected Permission",
    your_selected_program: "Program You Selected",
    your_selected_classrooms: "Your Selected Classrooms",
    you_dont_have_any_invoice: "You don`t have any invoices",
    yks: "YKS",
    exam_schedules_double_course_control:
        "Double Course Control",
    double_course_control: "Double Course Control",
    exam_schedule_report: "Courses Not Included in the Exam Schedule",
    isThereExamSchedule: "Is there an exam schedule?",
    group_name: "Group Name",
    group_name_en: "Group Name (EN)",
    group_ticket_for: "Group Ticket for",
    group_ticket_info: "For your event participation, a special certificate for corporate employees will be awarded.",
    group_ticket: "Group Ticket",
    bulk_approval: "Bulk Approval",
    bulk_message: "Bulk Message",
    bulk_address_update: "Bulk Address Update",
    bulk_import: "Bulk import operations",
    bulk_import_button: "Bulk Import",
    bulk_delete_permit: "Bulk Delete Permit",
    bulk_note_entry: "Bulk Note Entry",

    // Z

    message_sent_student: "Message sent to {number} student",
    application_information_is_awaited: "Application information is awaited.",
    preference_information_is_awaited: "Preference information is awaited.",
    required_documents_is_awaited:
        "Required documents are expected to be sent.",
    required_documents_approval_is_awaited:
        "Required documents are awaited approval.",
    your_application_has_been_accepted: "Your application has been accepted.",
    your_application_has_been_rejected: "Your application has been rejected.",
    your_application_publish: "Your application has been finalized.",
    your_application_has_been_received: "Your application has been received.",
    your_application_has_been_evaluated: "Your application has been evaluated.",
    your_application_has_been_submitted: "Your application has been submitted.",
    your_application_has_been_sent_successfully: "Your application has been sent successfully",
    your_turkmer_application_has_been_sent_successfully: "Your application has been received. You can track the process by visiting https://umisapi.bau.edu.tr/turkmer/login",
    undergraduate_transfer_start:
        "You can start your transfer application process by clicking the button below.",
    you_choose_courses_to_improve_your_grades_are_you_sure:
        "You choose courses to improve your grades. Are you sure?",

    minor_status_obj: {
        waiting: "Application are pending",
        waiting_preference: "Preferences are pending",
        waiting_prep_school: "Prep school awaits",
        waiting_academic_unit_office: "Academic unit expected",
    },

    short_name_desc: "Z-A Short",
    short_name_asc: "A-Z Short",
    short_number_desc: "0-9 Short",
    short_number_asc: "9-0 Short",
    verification_via_sms: "Verification Via Sms",
    verification_with_authenticator_app: "Verification with Authenticator App",
    two_factor_app_info: "Scan the QR code with the Authenticator application, write the code given by the application in the field below and click the Confirm button.",
    copy_course_outcomes: "Course Outcomes Copy",
    copy_program_outcomes: "Program Outcomes Copy",
    copy_course_descriptions: "Course Descriptions Semester Copy",
    copy_weekly_course_plans: "Weekly Course Plan Semester Copy",
    copy_course_assessments: "Course Assessment Semester Copy",
    copy_course_workloads: "Course Workload Semester Copy",
    from_semester: "From Semester",
    to_semester: "To Semester",

    // Special Student Application
    rejected_documents_warning: "Rejected Documents",
    please_reupload_rejected_documents: "Please re-upload the documents rejected by the student affairs.",
    rejected_documents: "Rejected Documents",
    documents_uploaded_successfully: "Documents Uploaded Successfully",
    missing_documents_uploaded_desc: "Your missing or rejected documents have been successfully uploaded to the system. You can continue to track the status of your application.",
    back_to_home: "Back to Home",
    waiters_rejected_courses: "Course Selection Rejected",
    please_reupload_rejected_courses: "Please remove your rejected courses from the list, select new courses instead, and save.",
    course_revision_success_title: "Course Registration Successfully Updated",
    course_revision_success_desc: "The new courses you selected to replace your rejected courses have been successfully submitted to the system. You can continue to track the status of your application.",
    application_accepted_title: "Application Accepted",
    application_accepted_desc: "Congratulations! Your special student application has been approved. You can proceed by clicking the button below to complete your registration and payment.",
    waiting_approval_documents_desc: "Your documents are currently in the Student Affairs approval process. No changes can be made.",
    waiting_secretary_approval_desc: "The courses you selected are currently in the Faculty Secretary approval process. No changes can be made.",
    revision_required: "Revision Required",
    some_documents_rejected_info: "Some of the documents you uploaded have been rejected. Please check the relevant documents and re-upload them.",
    document_rejected_reupload_info: "This document has been rejected by the administrator. Please re-upload the correct document.",
    click_to_reupload: "click to re-upload",
    click_to_select: "click to select",

    new_file_selected: "New File Selected",
    click_save_to_upload: "Press Save to upload",
    library_closed_holiday: "Our Library is Closed Due to Public Holiday",
    library_closed_holiday_desc: "Our library is closed for reservations on the selected date {date} due to the public holiday {holiday}.",
    library_holiday_day: "Library Holiday Day",
    please_select_another_date_for_reservation: "Please select another date to make a reservation.",
    prep_student_document_title: "Excuse Report and My Documents",
    prep_student_document_desc: "You can upload and track your health reports and excuse documents here.",
    upload_new_document: "Upload New Document",
    application_history: "Application History",
    loading_documents_wait: "Your documents are loading, please wait...",
    no_registered_documents: "No Registered Documents Found",
    no_registered_documents_desc: "You do not have any uploaded excuse reports or documents yet.",
    upload_first_document: "Upload Your First Document",
    new_document_submission: "New Document Submission",
    document_attached: "Document Attached",
    student_meb_not_graduated_warning: "Öğrencinin lise mezuniyeti yok",
    student_must_apply_to_military_office_warning: "Öğrencinin Askerlik Şubesine başvurması gerekiyor",
};

export default translations;
